// Basic Vue components
import { createApp } from 'vue'
import 'vue-style-loader';
import Viewer from './components/viewer.vue';

// Setup Vue
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Event Bus
window.EventBus = new class {
    constructor() {
        this.vue = window.createApp;
    }

    emit(event, data = null) {
        // console.log("event called!");
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        // console.log("event found!");
        this.vue.$on(event, callback);
    }
};

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
import oasisModal from './components/oasis-modal.vue';
import signaturePad from './components/signaturePad.vue';
import Dropzone from 'vue2-dropzone';
import DateField from './components/DateField.vue';
import InventoryMixin from './mixins/InventoryMixin';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
require ('./classes/PrototypeExt.js');
import addressAutocomplete from './components/addressAutocomplete.vue';
import IntlMixin from './mixins/IntlMixin.js';
import UtilitiesMixin from './mixins/UtilitiesMixin.js';
import DateFormatUtil from './mixins/DateFormatUtil.js';
import { DateTime } from 'luxon';

var app = createApp({

    components: {
        'modal-dynamic': modalDynamic,
        'signature-pad': signaturePad,
        'oasis-modal': oasisModal,
        Dropzone,
        DateField,
        Viewer,
        Multiselect,
        'address-autocomplete': addressAutocomplete
    },

    mixins: [ InventoryMixin, IntlMixin, DateFormatUtil, UtilitiesMixin ],

    data() {
        return {
            adminAccess: false,
            isWorkPlaceChanged: false, // to detect changes about work place in approve page
            localFormatCertificationDate: '',
            format: 'MM/dd/yyyy',
            localFormatBirthDate: '',
            convertStartDate: '',
            convertTermDate: '',
            multiSelectChanged: false,
            entityType: '',
            selectedEntityType: '',
            hasPrepWrap: false,
            isPermanentUpdated: false,
            isMailingUpdated: false,
            isLoanoutUpdated: false,
            isAgentUpdated: false,
            isAgentAutoCompleted: false,
            isPermanentAutoCompleted: false,
            isMailingAutoCompleted: false,
            isLoanoutAutoCompleted: false,
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            waiting: false, // loading spinner
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            ddMessage: false,
            ddMessage2: false,
            type: '',
            isPermanentAddressChanged: false,
            isMailingAddressChaned: false,
            isLoanoutAddressChanged: false,
            isAgentAddressChanged: false,
            isAgentOverride: false,
            isPermanentOverride: false,
            isMailingOverride: false,
            isLoanoutOverride: false,
            errors: {
                'tin': false,
                'foreign_tin': false,
                'birth_date': false,
                'fein': false,
                'list_b_type_id': false,
                'list_c_type_id': false,
                'list_a_number': false,
                'list_b_number': false,
                'list_c_number': false,
                'list_a_exp': false,
                'list_b_exp': false,
                'list_c_exp': false,
                'ee_list_b_type_id': false,
                'ee_list_c_type_id': false,
                'ee_list_a_number': false,
                'ee_list_b_number': false,
                'ee_list_c_number': false,
                'ee_list_a_exp': false,
                'ee_list_b_exp': false,
                'ee_list_c_exp': false,
                'certification_completion_date': false,
                'password': false,
                'repeatPassword': false,
            },
            changed: {
                'tin': false,
                'foreign_tin': false,
                'birth_date': false,
                'fein': false,
                'list_b_type_id': false,
                'list_c_type_id': false,
                'list_a_number': false,
                'list_b_number': false,
                'list_c_number': false,
                'list_a_exp': false,
                'list_b_exp': false,
                'list_c_exp': false,
                'ee_list_b_type_id': false,
                'ee_list_c_type_id': false,
                'ee_list_a_number': false,
                'ee_list_b_number': false,
                'ee_list_c_number': false,
                'ee_list_a_exp': false,
                'ee_list_b_exp': false,
                'ee_list_c_exp': false,
                'certification_completion_date': false,
            },
            finished: [], // Shows which sections have been completed by the employee
            failed: [], // Shows which sections have been started and not completed by the employee
            changes: [], // track changes
            viewerModal: false, // Show the viewer modal?
            approveModal: false, // Show the approval modal?
            kickbackModal: false, // Show the approval modal?
            employerMessage: '', // For the kickback modal
            documentModal: false, // Show the documents modal?
            loanoutDocModal: false, // Show the documents modal?
            agentDocModal: false, // Show the documents modal?
            i9DocModal: false, // Show the documents modal?
            residencyDocModal: false,
            ddDocModal: false, // Show the documents modal?
            certDocModal: false, // Show the documents modal?
            paperFormModal: false, // Show the paperform modal?
            everifyModal: false,
            w4Modal: false,
            td1Modal: false,
            allowanceModal: false,
            empLocked: false, // make the employee read only?
            oasisApi: '',
            oasisV3Api: '',
            endpoints: {},

            // List of starts to go back/forth
            startList: [],

            // Custom Forms and acknowledgements
            employeeApprovalStep: 0,
            employeeStartLink: undefined,
            customForms: customForms,
            customDocuments: [],
            acknowledge: { 0: false },
            directDeposit: false,
            dd_acknowledge: false,
            loanout_acknowledge: false,
            i9_verified: false,
            isSigned: false,
            readonlyI9: false,
            readonly: readonly || false,
            readonlyFinal: readonlyFinal || false,
            disableLoanouts: false, 
            requireI9Information: false,
            enforceLoanoutI9: false,
            enableLoanoutsEmployee: false,
            encourageLicenseUpload: false,
            stateFormsNotRequired: false,
            repeatPassword: undefined,
            isNewUser: undefined,

            // New forms for employees
            currentStep: 'Start',

            // employees/locations retrieved from database
            states: [],

            // Employer Details`
            employer: {
                id: '',
                signature: '',
                first_name: '',
                last_name: '',
            },

            // Employee Details`
            employee: {
                id: '',
                empId: '',
                tin: '',
                foreign_tin: '',
                birth_date: '',
                last_name: '',
                first_name: '',
                middle_name: '',
                password: '',
                alt_name: '',
                gender_id: '',
                email: '',
                mobile_phone: '',
                second_phone: '',
                main_address1: '',
                main_address2: '',
                main_city: '',
                main_state: '',
                main_state_id: '',
                main_postal: '',
                main_country: '',
                main_country_id: '',
                marital_status_id: '',
                exemptions: '',
                exemptions_state: '',
                citizenship_id: '',
                alien_no: '',
                ethnicity_id: '',
                ethnicity_other: '',
                mailing_address1: '',
                mailing_address2: '',
                mailing_city: '',
                mailing_state: '',
                mailing_state_id: '',
                mailing_postal: '',
                mailing_country: '',
                mailing_country_id: '',
                signature: '',
                loanout_name: '',
                loanout_ein: '',
                loanout_ca_edd: '',
                loanout_owner: '',
                loanout_owner_title: '',
                loanout_states_registered: [],
                loanout_address1: '',
                loanout_address2: '',
                loanout_city: '',
                loanout_state_id: '',
                loanout_postal: '',
                loanout_country: 'US',
                loanout_country_id: 1,
                special_type: '',
                special_type_properties: {},
                show_agent: '',
                // 2020 W4 new
                w4_exempt: 0,
                w4_job_count: 1,
                w4_children: 0,
                w4_other_dependents: 0,
                w4_dependent_adj: 0,
                w4_other_income: '',
                w4_deductions: '',
                w4_extra_wh: '',
                state_extra_wh: '',
                state_forms: [],
                state_form_fields: {},
                metadata: { residentState: {}},
                previousDD: undefined,
            },

            // Signature Pad
            signatureOptions: {},

            // Assignment details
            assignment: {
                id: '',
                start_date: '',
                term_date: '',
                rate: '',
                rate_unit_id: '',
                rate_unit: '',
                guaranteed_hours: '',
                guaranteed_hours_unit_id: '',
                guaranteed_hours_unit: '',
                hourly_rate: '',
                rate_comment: '',
                job_order: 1,
                job_title: '',
                job_title_id: '',
                job_title_override: '',
                legislative_type_id: '',
                loanout_status: '',
                currency_id: '',
                currency: '',
                legislative_type: '',
                flsa_type_id: '',
                rule_collection: '',
                rule_collection_id: '',
                union_local: '',
                union_local_id: '',
                location_id: '',
                location: '',
                location_city: '',
                location_state: '',
                aca_status_id: '',
                aca_status: '',
                employee: '',
                employee_id: '',
                is_supervisor: '',
                certification_type_id: '',
                entity:'',
                entity_id:'',
                budget_code: '',
                fringe_code: '',
                free_field: '',
                free_field2: '',
                kit_rental: '',
                kit_rental_tax: '',
                per_diem: '',
                per_diem_taxable: '',
                per_diem_advance: '',
                car_rental: '',
                other: '',
                mileage: '',
                mileage_rate: '',
                kr_code: '',
                pd_code: '',
                pd_taxable_code: '',
                pd_advance_code: '',
                cr_code: '',
                mi_code: '',
                other_code: '',
                kr_free_field: '',
                pd_free_field: '',
                pdtax_free_field: '',
                pdadv_free_field: '',
                cr_free_field: '',
                mi_free_field: '',
                other_free_field: '',
                status: '',
                occ_code: '',
                kit_inventory_id: null,
                agreement: '',
                agreement_id: '',
                union_local: '',
                union_local_id: '',
                union_dues_withholding: '',
                union_dues_withholding_id: '',
                union_member: '',
                union_member_id: '',
                i9_verifier: '',
                i9_verifier_id: '',
                i9_verified_date: '',
                is_rehire: '',
                list_a_type: '',
                list_a_type_id: '',
                list_a_number: '',
                list_a_auth: '',
                list_a_exp: '',
                list_b_type: '',
                list_b_type_id: '',
                list_b_number: '',
                list_b_auth: '',
                list_b_exp: '',
                list_c_type: '',
                list_c_type_id: '',
                list_c_number: '',
                list_c_auth: '',
                list_c_exp: '',
                ee_list_a_type_id: null,
                ee_list_a_auth: null,
                ee_list_a_number: null,
                ee_list_a_exp: null,
                ee_list_b_type_id: null,
                ee_list_b_auth: null,
                ee_list_b_number: null,
                ee_list_b_exp: null,
                ee_list_c_type_id: null,
                ee_list_c_auth: null,
                ee_list_c_number: null,
                ee_list_c_exp: null,

                // Direct Deposit
                dd_status: null,
                dd_bank_name_1: '',
                dd_bank_city_state_1: '',
                dd_bank_account_name_1: '',
                dd_bank_account_1: '',
                dd_bank_confirm_1: '',
                dd_bank_routing_1: '',
                dd_bank_branch_1: '',
                dd_bank_amount_1: '',
                dd_bank_percent_1: '',
                dd_bank_type_1: '',
                dd_bank_name_2: '',
                dd_bank_city_state_2: '',
                dd_bank_account_name_2: '',
                dd_bank_account_2: '',
                dd_bank_confirm_2: '',
                dd_bank_routing_2: '',
                dd_bank_branch_2: '',
                dd_bank_type_2: '',
                dd_bank_amount_2: '',
                dd_bank_percent_2: '',

                custom_forms: {},
                custom_form_employer_fields: {},
                custom_form_fields: {},
                canada_form_fields: { td1: {} },
                employee_comments: '',
                employer_comments: '',
                metadata: {},
            },

            // W-4 allowance calc
            w4: {
                self: 1,
                spouse: 0,
                dependents: 0,
                household: 0,
                credits: 0,
                deduction_amount: null,
                auto: 1,
                exempt: false,
                exempt_state: false,
                // 2020 new fields
                jobs: 1,
                jobsSpouse: 0,
            },
            // Preselect
            newMainState: '',
            newMailingState: '',
            newLoanoutState: '',
            // Dropzone Options
            dzoptions: {
                headers: { "Auth": authToken },
                acceptedFileTypes: ".txt,.pdf,.jpeg,.jpg,.heic,.png,.tif,.tiff,.doc,.docx,.xls,.xlsx",
                maxFileSizeInMB: 12,
                uploadMultiple: true,
                maxNumberOfFiles: 5,
                showRemoveLink: false,
                thumbnailHeight: 20,
                thumbnailWidth: 20,
            },

            assets: [],
            ddAssets: [],
            uploadedDdAsset: false,

            // Required
            requiredAlways: [
                { name: 'SSN', field: 'employee.tin' },
                { name: 'Birth Date', field: 'employee.birth_date' },
                { name: 'Last Name', field: 'employee.last_name' },
                { name: 'First Name', field: 'employee.first_name' },
                { name: 'Marital Status', field: 'employee.marital_status_id' },
                { name: 'Email', field: 'employee.email' },
                { name: 'Main Address1', field: 'employee.main_address1' },
                { name: 'Main City', field: 'employee.main_city' },
                { name: 'Main State', field: 'employee.main_state_id' },
                { name: 'Main Postal', field: 'employee.main_postal' },
                { name: 'Main Country', field: 'employee.main_country' },
                { name: 'Citizenship', field: 'employee.citizenship_id' },
            ],
            requiredLoanout: [
                { name: 'Loanout Company Name', field: 'employee.loanout_name' },
                { name: 'Loanout FEIN', field: 'employee.loanout_ein' },
                { name: 'Loanout CA EDD #', field: 'employee.loanout_ca_edd' },
                { name: 'Loanout Type', field: 'employee.loanout_type_id' },
                { name: 'Loanout Owner Name', field: 'employee.loanout_owner' },
                { name: 'Loanout Owner Title', field: 'employee.loanout_owner_title' },
                { name: 'Loanout Address 1', field: 'employee.loanout_address1' },
                { name: 'Loanout City', field: 'employee.loanout_city' },
                { name: 'Loanout State', field: 'employee.loanout_state_id' },
                { name: 'Loanout Zip', field: 'employee.loanout_postal' },
                { name: 'Loanout Country', field: 'employee.loanout_country' },
            ],
            requiredAgent: [
                { name: 'Agent Name', field: 'employee.special_type_properties.agent_name' },
                { name: 'Agency Name', field: 'employee.special_type_properties.agency_name' },
                { name: 'Agency Address1', field: 'employee.special_type_properties.agency_address1' },
                { name: 'Agency City', field: 'employee.special_type_properties.agency_city' },
                { name: 'Agency State', field: 'employee.special_type_properties.agency_state_id' },
                { name: 'Agency Postal', field: 'employee.special_type_properties.agency_postal' },
            ],
            requiredDD1: [
                // { name: 'Direct Deposit Acknolwedgement', field: 'dd_acknowledge' },
                { name: 'Bank 1 Type', field: 'assignment.dd_bank_type_1' },
                { name: 'Bank 1 Name', field: 'assignment.dd_bank_name_1' },
                { name: 'Full Name on Bank 1', field: 'assignment.dd_bank_account_name_1' },
                { name: 'Bank 1 City and State', field: 'assignment.dd_bank_city_state_1' },
                { name: 'Bank 1 Routing Number', field: 'assignment.dd_bank_routing_1' },
                { name: 'Bank 1 Account Number', field: 'assignment.dd_bank_account_1' },
            ],
            requiredDD2: [
                { name: 'Bank 2 Type', field: 'assignment.dd_bank_type_2' },
                { name: 'Bank 2 Name', field: 'assignment.dd_bank_name_2' },
                { name: 'Full Name on Bank 2', field: 'assignment.dd_bank_account_name_2' },
                { name: 'Bank 2 City and State', field: 'assignment.dd_bank_city_state_2' },
                { name: 'Bank 2 Routing Number', field: 'assignment.dd_bank_routing_2' },
                { name: 'Bank 2 Account Number', field: 'assignment.dd_bank_account_2' },
            ],

            errors: [],

            // For sexual harassment certification
            projectLocations: [],
            certifications: [],
            certPanel: true,
            isCertified: undefined,
            harassmentCertification: undefined,
            companyHarassmentSupCertificateId: undefined,
            companyHarassmentCertificateId: undefined,
            certificationTypes: [],
            certificationStatus: {
                id: undefined,
                employee_id: undefined,
                certification_number: undefined,
                certification_type_id: undefined,
                completion_date: undefined,
                trainer: '',
            },
            // error will be received as array from postgrid
            error_main_address1: '',
            error_main_city: '',
            error_main_state: '',
            error_main_generic: '',
            error_main_postal: '',
            error_mailing_address1: '',
            error_mailing_city: '',
            error_mailing_state: '',
            error_mailing_generic: '',
            error_mailing_postal: '',
            error_loanout_address1: '',
            error_loanout_city: '',
            error_loanout_state: '',
            error_loanout_generic: '',
            error_loanout_postal: '',
            error_agent_address1: '',
            error_agent_city: '',
            error_agent_state: '',
            error_agent_generic: '',
            error_agent_postal: '',
            showHistory: false,
            history: undefined,
        }
    },

    computed: {
        is_loanout() {
            return this.assignment.loanout_status == 1 ? true : false;
        },
        height() {
            return window.innerHeight * 0.92;
        },
        width() {
            // Reducing by % to handle sigma-frontend navbar
            return window.innerWidth;
        },

        // For employees only to acknowledge custom messages.
        approvalMessages() {
            if (this.type === 'employer') return undefined;

            let messages = [];

            // Add Agent Auth
            if (parseInt(this.employee.special_type) === 1) {
                messages.push({ id: '0-agent', required: 1, message: 'I authorize my agency ' + ((this.employee.special_type_properties || {}).agency_name || '') + ' to receive funds on my behalf.'});
            }

            let selectedForms = this.assignment.custom_forms;
            for (let i = 0; i < selectedForms.length; i++) {
                if (! this.customForms || this.customForms.length === 0) continue;

                let form = this.customForms.find( ({ id, ack_required }) => id == selectedForms[i] && ack_required == 1);
                if (form && this.isJson(form.ack_message) && Array.isArray(JSON.parse(form.ack_message))) {
                    let data = JSON.parse(form.ack_message);
                    for (let i = 0; i < data.length; i++) {
                        // assume acknowledgement is required if array of messages. TODO make ack.required an array
                        let subId = form.id + '-' + i;
                        let message = { id: subId, required: 1, message: data[i] };
                        messages.push(message);
                        // console.log ('Array');
                        // console.log ('');
                        if (message.required == 1 && ! this.acknowledge[message.id]) this.acknowledge[message.id] = false;
                    }
                // } else if (form && form.ack_message && Array.isArray(form.ack_message)) {
                } else if (form) {
                    let message = { id: form.id, required: form.ack_required, message: form.ack_message };
                    messages.push(message);
                    //  Create a blank value for checkbox validation
                    if (message.required == 1 && ! this.acknowledge[message.id]) this.acknowledge[message.id] = false;
                }
            }

            return messages;
        },

        loAssets() {
            return this.assets.filter( ({ type }) => type === 'loanout');
        },

        i9Docs() {
            return this.assets.filter( ({ type }) => type === 'i9doc');
        },

        ddDocs() {
            return this.assets.filter( ({ type }) => type === 'voidedCheck');
        },

        certDocs() {
            return this.assets.filter( ({ type }) => type === 'certdoc');
        },

        boxDocs() {
            return this.assets.filter( ({ type }) => type === 'boxdoc');
        },

        totalAllowances () {
            let total = 0;
            for (let allowance in this.w4) {
                if (allowance === 'exempt' || allowance === 'exempt_state') continue;
                total += parseInt(this.w4[allowance]);
            }
            return total;
        },

        // TODO hack
        everifyEligible () {
            if (this.assignment.location_state === 'GA') return true;
            else return false;
        },
        
        ratePerUnit () {
            let hourly = parseInt(this.assignment.rate_unit_id) === 1 ? '' : ' (' + (this.hourlyRate) + ')';
            return this.assignment.rate + ' / ' + this.assignment.rate_unit + hourly;
        },

        guaranteePerUnit () {
            if (!this.assignment.guaranteed_hours) return '';
            else return parseFloat(this.assignment.guaranteed_hours).toFixed(2) + ' ' + this.assignment.guaranteed_hours_unit;
        },

        hourlyRate () {
            return (this.assignment.hourly_rate) ? this.assignment.hourly_rate + ' / Hour' : '';
        },

        fullJobTitle () {
            const title = this.assignment.union_local_id && parseInt(this.assignment.legislative_type_id) === 4 ? this.assignment.job_title + ' (' + this.assignment.job_title_override + ')' : this.assignment.job_title_override;
            return title; // + ' (' + this.assignment.legislative_type + ')';
        },

        customFormFields () {
            if (this.assignment.custom_forms.length < 1) return null;
            else if (typeof this.assignment.custom_form_fields !== 'object') return null;
            else if (Object.keys(this.assignment.custom_form_fields).length === 0) return null;
            else return Object.keys(this.assignment.custom_form_fields);
        },

        customFormEmployerFields () {
            if (this.assignment.custom_forms.length < 1) return null;
            else if (typeof this.assignment.custom_form_employer_fields !== 'object') return null;
            else if (Object.keys(this.assignment.custom_form_employer_fields).length === 0) return null;
            else return Object.keys(this.assignment.custom_form_employer_fields);
        },

        customDocumentsWithFormFields () {
            let docs = [];
            if (this.assignment.custom_forms.length < 1) return docs;
            else if (typeof this.assignment.custom_form_fields !== 'object') return docs;
            else if (Object.keys(this.assignment.custom_form_fields).length === 0) return docs;
            else {
                this.customDocuments.map((doc) => {

                })
            }
        },

        customEmployerForms () {
            return this.customForms.filter(({id, fields}) => {
                let formMatch = (this.assignment.custom_forms && Array.isArray(this.assignment.custom_forms) && (this.assignment.custom_forms || []).includes(id)) ? true : false;
                let matches = fields.find((field) => field.role === 'employer');
                if (formMatch && matches) return true;
            });
        },

        customEmployeeForms () {
            return this.customForms.filter(({id, fields}) => {
                let formMatch = (this.assignment.custom_forms && Array.isArray(this.assignment.custom_forms) && (this.assignment.custom_forms || []).includes(id)) ? true : false;
                let matches = fields.find((field) => field.role === 'employee');
                if (formMatch && matches) return true;
            });
        },

        stateForms() {
            if (! stateForms || ! Array.isArray(stateForms)) return [];
            else return stateForms.filter((form) => parseInt(form.document_type_id || 0) === 99);
        },

        selectedStateForms() {
            if (! this.employee.state_forms || ! Array.isArray(this.employee.state_forms)) {
                return [];
            } else {
                const stateForms = this.stateForms.filter( ( { id } ) => this.employee.state_forms.map(formId => parseInt(formId)).includes(parseInt(id)) );
                const incentiveForms = this.incentiveForms.filter( ( { id } ) => this.employee.state_forms.map(formId => parseInt(formId)).includes(parseInt(id)) );
                return stateForms.concat(incentiveForms);
            }
        },

        incentiveForms() {
            if (! stateForms || ! Array.isArray(stateForms)) return [];
            else return stateForms.filter((form) => parseInt(form.document_type_id || 0) === 157);
        },

        incentiveStates() {
            if (! this.incentiveForms || ! Array.isArray(this.incentiveForms)) return [];
            const incentiveFormStates = [ ... new Set(this.incentiveForms.map((form) => parseInt(((form.properties || {}).locations || {}).defaultState || 0))) ];
            const intersection = this.allLocationStateIds.filter(state => incentiveFormStates.includes(state));
            const states = this.states.filter((state) => intersection.includes(parseInt(state.id)));
            return states;
        },

        matchingIncentiveForms() {
            if (! this.incentiveForms || ! Array.isArray(this.incentiveForms) || ! this.employee.metadata.residentState || typeof this.employee.metadata.residentState !== 'object') return [];
            const incentiveForms = [ ... new Set(this.incentiveForms.filter((form) => this.employee.metadata.residentState[parseInt(((form.properties || {}).locations || {}).defaultState || 0)])) ];
            return incentiveForms;
        },

        mainLocation () {
            return this.projectLocations.find(({ id }) => parseInt(id) === parseInt(this.assignment.location_id)) || {};
        },

        mainLocationState () {
            if (this.projectLocations.length === 0) return null;
            else return this.mainLocation.state || null;
        },

        allLocationStateIds () {
            if (this.projectLocations.length === 0) return [];
            return [ ...new Set(this.projectLocations.map((loc) => parseInt(loc.state_id))) ]
        },

        isLoanout() {
            return this.assignment.loanout_status && this.assignment.loanout_status !== '0' ? true : false;
        },

        isCertificationRequired() {
            // Enabled in ENTITY model
            // console.log('harassmentCertification', this.harassmentCertification)
            if (typeof this.harassmentCertification === 'undefined' || ! this.harassmentCertification) {
                return false;
            }

            let certificationTypeId = this.assignment.certification_type_id || null;
            if (!certificationTypeId) {
                // Hard coded to look for CA and NY state work locations
                // Add the certification types here for older starts
                if (this.mainLocationState === 'CA' && this.is_supervisor === true) {
                    certificationTypeId = 2;
                } else if (this.mainLocationState === 'CA') {
                    certificationTypeId = 1;
                } else if (this.mainLocationState === 'NY') {
                    certificationTypeId = 3;
                } else if (this.mainLocationState === 'ON') {
                    certificationTypeId = 4;

                // Allow non-CA and NY workers to use the certification
                } else if (this.companyHarassmentSupCertificateId && this.is_supervisor === true) {
                    certificationTypeId = this.companyHarassmentSupCertificateId;
                } else if (this.companyHarassmentCertificateId) {
                    certificationTypeId = this.companyHarassmentCertificateId;
                } else {
                    // this.assignment.certification_type_id = null;
                }
            }

            if (certificationTypeId) {
                if (!this.assignment.certification_type_id) this.assignment.certification_type_id = certificationTypeId;
                if (!this.certificationStatus.certification_type_id) this.certificationStatus.certification_type_id = certificationTypeId;
                if (!this.certificationStatus.employee_id) this.certificationStatus.employee_id = this.assignment.employee_id;
                return true;
            } else {
                return false;
            }
        },

        nextStart () {
            const current = this.startList.indexOf(this.assignment.hash) || null;
            let next;

            if (current >= 0) {
                next = current + 1;
                return this.startList[next];
            } else {
                return next;
            }
        },
        prevStart () {
            // console.log(this.startList, this.assignment.hash)
            const current = this.startList.indexOf(this.assignment.hash) || null;
            let next;

            if (current > 0) {
                next = current - 1;
                return this.startList[next];
            } else {
                return next;
            }
        },
        // Possible that we will have a show that is both foreign and domestic at some point.  
        isForeign() {
            return (parseInt(this.assignment.currency_id)) > 1 || (parseInt(this.employee.main_country_id)) > 1 || (parseInt(this.mainLocation.country_id)) > 1;
        },
        isCanada() {
            return (parseInt(this.assignment.currency_id)) === 2 || (parseInt(this.employee.main_country_id)) === 2 || (parseInt(this.mainLocation.country_id)) === 2;
        },
        isSsnNeeded() {
            return (parseInt(this.assignment.currency_id)) === 1 || (parseInt(this.employee.main_country_id)) === 1 || (this.employee.citizenship_id && ([ 17, 18, 19, 239 ].includes(parseInt(this.employee.citizenship_id))));
        },
        isW4Needed() {
            return (parseInt(this.assignment.currency_id)) === 1 || (parseInt(this.employee.main_country_id)) === 1 || (parseInt(this.mainLocation.country_id))  === 1;
        },
        isI9Needed() {
            return parseInt(this.assignment.currency_id) === 1 || parseInt(this.mainLocation.country_id) === 1;
        },
        isComplete() {
        },

        // Show or hide certain panels
        showUnion() {
            return this.assignment.union_local_id && parseInt(this.assignment.union_local_id) > 0;
        },
        showLoanout() {
            return parseInt(this.assignment.loanout_status) === 1 || this.enableLoanoutsEmployee && !this.disableLoanouts
        },
        showAgent() {
            return this.employee.show_agent > 0;
        },
        showTaxInfo() {
            return true;
        },
        showStateForms() {
            return true;
        },
        showCountryForms() {
            return false;
        },
        showCustomForms() {
            return this.customFormFields ? true : false;
        },
        showEmploymentAuthorization() {
            return isI9Needed;
        },
        showCanada() {
            return this.isCanada;
        },
        showForeign() {
            return this.isForeign;
        },
        showW4Box() {
            return this.isW4Needed && this.assignment.loanout_status == 0;
        },
        showEEO() {
            return !this.isForeign || this.isSsnNeeded;
        },
        showI9() {
            return !this.isForeign || (this.isSsnNeeded || this.enforceLoanoutI9);
        },
        showBoxInventory() {
            return (this.assignment.kit_rental && this.assignment.kit_rental > 0) || (this.assignment.kit_rental_tax && this.assignment.kit_rental_tax > 0);
        },
        showDirectDeposit() {
            return this.directDeposit;
        },
        showDirectDeposit1() {
            return this.directDeposit && this.assignment.dd_status > 0;
        },
        showDirectDeposit2() {
            return this.directDeposit && this.assignment.dd_status > 1;
        },
        showDirectDeposit3() {
            return this.directDeposit && this.assignment.dd_status > 0;
        },
        showApproval0() {
            return true;
        },
        showApproval1() {
            return true;
        },
        showApproval2() {
            return true;
        },
        showApproval3() {
            return true;
        },
        showEmployeeCertification() {
            return this.isCertificationRequired;
        },

        // Show or hide certain panels
        finishedStart() {
            return this.finished.indexOf('Start') >= 0;
        },
        finishedJobInfo() {
            return this.finished.indexOf('JobInfo') >= 0;
        },
        finishedUnion() {
            return this.finished.indexOf('Union') >= 0;
        },
        finishedEmployeeDetails() {
            return this.finished.indexOf('EmployeeDetails') >= 0;
        },
        finishedAddress() {
            return this.finished.indexOf('Address') >= 0;
        },
        finishedMailingAddress() {
            return this.finished.indexOf('MailingAddress') >= 0;
        },
        finishedDemographics() {
            return this.finished.indexOf('Demographics') >= 0;
        },
        finishedLoanout() {
            return this.finished.indexOf('Loanout') >= 0;
        },
        finishedAgent() {
            return this.finished.indexOf('Agent') >= 0;
        },
        finishedTaxInfo() {
            return this.finished.indexOf('TaxInfo') >= 0;
        },
        finishedStateForms() {
            return this.finished.indexOf('StateForms') >= 0;
        },
        finishedCountryForms() {
            return this.finished.indexOf('CountryForms') >= 0;
        },
        finishedCanada() {
            return this.finished.indexOf('Canada') >= 0;
        },
        finishedCanadaRes() {
            return this.finished.indexOf('CanadaRes') >= 0;
        },
        finishedCustomForms() {
            return this.finished.indexOf('CustomForms') >= 0;
        },
        finishedEmploymentAuthorization() {
            return this.finished.indexOf('EmploymentAuthorization') >= 0;
        },
        finishedForeign() {
            return this.finished.indexOf('Foreign') >= 0;
        },
        finishedBoxInventory() {
            return this.finished.indexOf('BoxInventory') >= 0;
        },
        finishedDirectDeposit() {
            return this.finished.indexOf('DirectDeposit') >= 0;
        },
        finishedDirectDeposit1() {
            return this.finished.indexOf('DirectDeposit1') >= 0;
        },
        finishedDirectDeposit2() {
            return this.finished.indexOf('DirectDeposit2') >= 0;
        },
        finishedDirectDeposit3() {
            return this.finished.indexOf('DirectDeposit3') >= 0;
        },
        finishedApproval0() {
            return this.finished.indexOf('Approval0') >= 0;
        },
        finishedApproval1() {
            return this.finished.indexOf('Approval1') >= 0;
        },
        finishedApproval2() {
            return this.finished.indexOf('Approval2') >= 0;
        },
        finishedApproval3() {
            return this.finished.indexOf('Approval3') >= 0;
        },
        finishedEmployeeCertification() {
            return this.finished.indexOf('EmployeeCertification') >= 0;
        },
        failedStart() {
            return this.failed.indexOf('Start') >= 0;
        },
        failedJobInfo() {
            return this.failed.indexOf('JobInfo') >= 0;
        },
        failedUnion() {
            return this.failed.indexOf('Union') >= 0;
        },
        failedEmployeeDetails() {
            return this.failed.indexOf('EmployeeDetails') >= 0;
        },
        failedAddress() {
            return this.failed.indexOf('Address') >= 0;
        },
        failedMailingAddress() {
            return this.failed.indexOf('MailingAddress') >= 0;
        },
        failedDemographics() {
            return this.failed.indexOf('Demographics') >= 0;
        },
        failedLoanout() {
            return this.failed.indexOf('Loanout') >= 0;
        },
        failedAgent() {
            return this.failed.indexOf('Agent') >= 0;
        },
        failedTaxInfo() {
            return this.failed.indexOf('TaxInfo') >= 0;
        },
        failedStateForms() {
            return this.failed.indexOf('StateForms') >= 0;
        },
        failedCountryForms() {
            return this.failed.indexOf('CountryForms') >= 0;
        },
        failedCanada() {
            return this.failed.indexOf('Canada') >= 0;
        },
        failedCanadaRes() {
            return this.failed.indexOf('CanadaRes') >= 0;
        },
        failedCustomForms() {
            return this.failed.indexOf('CustomForms') >= 0;
        },
        failedEmploymentAuthorization() {
            return this.failed.indexOf('EmploymentAuthorization') >= 0;
        },
        failedForeign() {
            return this.failed.indexOf('Foreign') >= 0;
        },
        failedBoxInventory() {
            return this.failed.indexOf('BoxInventory') >= 0;
        },
        failedDirectDeposit() {
            return this.failed.indexOf('DirectDeposit') >= 0;
        },
        failedDirectDeposit1() {
            return this.failed.indexOf('DirectDeposit1') >= 0;
        },
        failedDirectDeposit2() {
            return this.failed.indexOf('DirectDeposit2') >= 0;
        },
        failedDirectDeposit3() {
            return this.failed.indexOf('DirectDeposit3') >= 0;
        },
        failedApproval0() {
            return this.failed.indexOf('Approval0') >= 0;
        },
        failedApproval1() {
            return this.failed.indexOf('Approval1') >= 0;
        },
        failedApproval2() {
            return this.failed.indexOf('Approval2') >= 0;
        },
        failedApproval3() {
            return this.failed.indexOf('Approval3') >= 0;
        },
        failedEmployeeCertification() {
            return this.failed.indexOf('EmployeeCertification') >= 0;
        },
        firstErrorPanel() {
            return (this.failed || [])[0] || undefined;
        },
        currentCertification() {
            if (!this.isCertificationRequired) return null;
            const result = this.certificationTypes.find(({id}) => parseInt(id) === parseInt(this.assignment.certification_type_id));
            return result || {};
        },
        isMissingStatesRegistered() {
            return this.is_loanout && this.employee.loanout_states_registered.length === 0;
        },
        isCaEddRequired() {
            // console.log(this.mainLocationState)
            return this.is_loanout && this.mainLocationState && this.mainLocationState === 'CA';
        },
        noCaEddNumber: {
            get: function () {
                if (!this.isCaEddRequired) return false;
                return this.employee.loanout_ca_edd === 'None';
            },
            set: function (value) {
                if (value === true) {
                    this.employee.loanout_ca_edd = 'None';
                } else {
                    this.employee.loanout_ca_edd = null;
                }
                // Mark as modified (when visible)
                const eddInput = this.$refs['employee.loanout_ca_edd'];
                if (eddInput) {
                    eddInput.classList.remove('form-error');
                    eddInput.classList.remove('form-missing');
                    eddInput.classList.add('form-change');
                }
            }
        },
    },

    methods: {
        checkBankRouting(bankNum, triggeredFrom) {
            // to avoid different flow (user put routing number first then, put bank_type)
            if (triggeredFrom == 'bankType') {
                // ignore if CANADA
                if (bankNum == 1) {
                    if (!this.assignment.dd_bank_routing_1 || this.assignment.dd_bank_type_1 == 'CANADA') return;
                } else {
                    if (!this.assignment.dd_bank_routing_2 || this.assignment.dd_bank_type_2 == 'CANADA') return;
                }
            } else {
                this.uploadedDdAsset = false; // origianl behavior
            }
            let bank;
            let bankType;
            let error = false;
            let message;
            if (bankNum == 1) {
                bank = 'dd_bank_routing_1';
                bankType = 'dd_bank_type_1';
            } else {
                bank = 'dd_bank_routing_2';
                bankType = 'dd_bank_type_2';
            }
            if (!this.$refs['assignment.' + bankType].value) {
                message = 'Please select account type.';
                error = true;
            }
            let bankInfo = this.$refs['assignment.' + bank]; // to access css
            let routingNum = bankInfo.value.replace(/[^0-9]+/g, ''); // allow only numbers
            if (!error) {
                if (bankNum == 1) this.assignment.dd_bank_routing_1 = routingNum; // reactivity
                if (bankNum == 2) this.assignment.dd_bank_routing_2 = routingNum; // reactivity
                if (routingNum.length > 0 && routingNum.length != 9) {
                    message = 'The bank routing number should be 9 digits. Please review and update.<br />';
                    error = true;
                }
            }
            if (!error && ( routingNum == '124303162' || routingNum == '124302529' || routingNum == '124303120' || routingNum == '124303124' || routingNum == '041208777' || routingNum == '041215663') ) {
                message = 'Green Dot Bank, Sutton Bank, or banks registered under either bank cannot be used for direct deposits. Please use a different bank to complete the direct deposit setup.<br />';
                error = true;
            }
            if (error) { 
                bankInfo.classList.add('form-error');
                this.createDialog({ "title": "Warning", "body": `${message}`, "buttonNo": false, "buttonYesLabel": "OK" });
            } else {
                bankInfo.classList.remove('form-error');
            }
        },
  
        checkBankName(bankNum) {
            let bank;
            if (bankNum == 1) {
                bank = 'dd_bank_name_1';
            } else {
                bank = 'dd_bank_name_2';
            }
            let bankInfo = this.$refs['assignment.' + bank];
            let bankName = bankInfo.value.replace(/\s/g, '').toLowerCase(); // remove all space
            if (bankNum == 1) this.assignment.dd_bank_name_1 = bankInfo.value.trim(); // remove space except space btw letters
            if (bankNum == 2) this.assignment.dd_bank_name_2 = bankInfo.value.trim(); // remove space except space btw letters
            if (bankName == 'go2bank' || bankName == 'gobank' || bankName == 'greendot' || bankName == 'bonnevillebank' || bankName == 'greendotbank' || bankName == 'suttonbank') {
                bankInfo.classList.add('form-error');
                this.createDialog({ "title": "Warning", "body": `Green Dot Bank, Sutton Bank, or banks registered under either bank cannot be used for direct deposits. Please use a different bank to complete the direct deposit setup.<br />`, "buttonNo": false, "buttonYesLabel": "OK" });
            } else {
                bankInfo.classList.remove('form-error');
            }
        },
        changedUnionLocal() {
            if (!this.multiSelectChanged) this.multiSelectChanged = true;
        },
        changeEntityType(hide) {
            if (this.employee.loanout_type_id) {
                this.selectedEntityType = this.entityType.find((data) => data.id == this.employee.loanout_type_id);
                if (!hide && ( this.selectedEntityType.code == 'C_LLC' || this.selectedEntityType.code == 'S_LLC' || this.selectedEntityType.code == 'CC_LLC' )) this.createDialog({ "title": "Warning", "body": `LLC's are not processed without an IRS election letter.<br />`, "buttonNo": false, "buttonYesLabel": "OK"  });
            } else {
                this.selectedEntityType = '';
            }
            
        },
        addressAutoComplete(address, section) {
            if (typeof(address) === 'object') {
                let state = this.states.find((element) => element.code == address.address.prov);
                let stateId;
                if (state) stateId = state.id;
                else stateId = 66;
                let countryId = address.address.country.toUpperCase() == 'US' ? 1 : 2;
                // postGrid issue - because of zip+4 code, when we send date to postGrid, they return "corrected" as a status instead of "verify".
                if (section === 'permanent') {
                    let removedZip4 = address.address.pc.split("-");
                    this.employee.main_address1 = address.address.address;
                    this.employee.main_city = address.address.city;
                    this.employee.main_state_id = stateId;
                    this.employee.main_country_id = countryId;
                    this.employee.main_postal = removedZip4[0];
                    this.isPermanentAutoCompleted = true;
                } else if (section === 'mailing') {
                    let removedZip4 = address.address.pc.split("-");
                    this.employee.mailing_address1 = address.address.address;
                    this.employee.mailing_city = address.address.city;
                    this.employee.mailing_state_id = stateId;
                    this.employee.mailing_country_id = countryId;
                    this.employee.mailing_postal = removedZip4[0];
                    this.isMailingAutoCompleted = true;
                } else if (section === 'loanout') {
                    let removedZip4 = address.address.pc.split("-");
                    this.employee.loanout_address1 = address.address.address;
                    this.employee.loanout_city = address.address.city;
                    this.employee.loanout_state_id = stateId;
                    this.employee.loanout_country_id = countryId;
                    this.employee.loanout_postal = removedZip4[0];
                    this.isLoanoutAutoCompleted = true;
                } else if (section === 'agent') {
                    let removedZip4 = address.address.pc.split("-");
                    this.employee.special_type_properties.agency_address1 = address.address.address;
                    this.employee.special_type_properties.agency_city = address.address.city;
                    this.employee.special_type_properties.agency_state_id = stateId;
                    this.employee.special_type_properties.agency_postal = removedZip4[0];
                    this.isAgentAutoCompleted = true;
                }
            } else {
                if (section === 'permanent') {
                    this.employee.main_address1 = address;
                } else if (section === 'mailing') {
                    this.employee.mailing_address1 = address;
                } else if (section === 'loanout') {
                    this.employee.loanout_address1 = address;
                } else if (section === 'agent') {
                    this.employee.special_type_properties.agency_address1 = address;
                }
            }
        },
        async checkAddressForm(hideDialog) {
            let permanentRes = true;
            let mailingRes = true;
            let loanoutRes = true;
            let agentRes = true;

            // have error, return false
            if (this.error_main_generic) permanentRes = false;
            if (this.error_mailing_generic) mailingRes = false;
            if (this.error_loanout_generic) loanoutRes = false;
            if (this.error_agent_generic) agentRes = false;

            // reset
            if (this.isPermanentUpdated) this.isPermanentUpdated = false;
            if (this.isMailingUpdated) this.isMailingUpdated = false;
            if (this.isLoanoutUpdated) this.isLoanoutUpdated = false;
            if (this.isAgentUpdated) this.isAgentUpdated = false;

            /* validation function will be ran below conditions
               1. A certain field was changed in address form
               2. US and Canada
               3. no error
               4. not address override
            */
            if (this.isPermanentAddressChanged && this.employee.main_state_id != 66 && permanentRes && !this.isPermanentOverride) {
                permanentRes = await this.verifyFields(this.employee.main_address1, this.employee.main_address2, this.employee.main_city, this.employee.main_state_id, this.employee.main_postal, this.employee.main_country_id, 'permanent');
                if (permanentRes) this.isPermanentAddressChanged = false;
            }
            if (this.isMailingAddressChanged && this.employee.mailing_state_id != 66 && mailingRes && !this.isMailingOverride) {
                if (this.employee.mailing_address1 || this.employee.mailing_address2 || this.employee.mailing_city || this.employee.mailing_state_id || this.employee.mailing_postal || this.employee.mailing_country_id) {
                    // mailing is not required fields. so If there is a certain value in mailing, validation will be ran, otherwise, skip it.
                    mailingRes = await this.verifyFields(this.employee.mailing_address1, this.employee.mailing_address2, this.employee.mailing_city, this.employee.mailing_state_id, this.employee.mailing_postal, this.employee.mailing_country_id, 'mailing');
                }
                if (mailingRes) this.isMailingAddressChanged = false;
            }
            if (this.isLoanoutAddressChanged && this.employee.loanout_state_id != 66 && loanoutRes && !this.isLoanoutOverride && this.assignment.loanout_status == 1) {
                loanoutRes = await this.verifyFields(this.employee.loanout_address1, this.employee.loanout_address2, this.employee.loanout_city, this.employee.loanout_state_id, this.employee.loanout_postal, this.employee.loanout_country_id, 'loanout');
                if (loanoutRes) this.isLoanoutAddressChanged = false;
            }
            if (this.isAgentAddressChanged && this.employee.special_type_properties.agency_state_id != 66 && agentRes && !this.isAgentOverride && this.employee.special_type == 1) {
                agentRes = await this.verifyFields(this.employee.special_type_properties.agency_address1, this.employee.special_type_properties.agency_address2, this.employee.special_type_properties.agency_city, this.employee.special_type_properties.agency_state_id, this.employee.special_type_properties.agency_postal, '', 'agent');
                if (agentRes) this.isAgentAddressChanged = false;
            }

            if (permanentRes && mailingRes && loanoutRes && agentRes) {
                return true;
            } else {
                if (!hideDialog) this.createDialog({ "title": "Warning", "body": 'Please check address fields before submitting.<br />', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            }
        },
        // address override
        overrideAddress(section) {
            if (section === 'permanent') {
                this.removeErrorMessage('permanent');
                this.isPermanentOverride = true;
                this.isPermanentUpdated = false;
            } else if (section === 'mailing') {
                this.removeErrorMessage('mailing');
                this.isMailingOverride = true;
                this.isMailingUpdated = false;
            } else if (section === 'loanout') {
                this.removeErrorMessage('loanout');
                this.isLoanoutOverride = true;
                this.isLoanoutUpdated = false;
            } else if (section === 'agent') {
                this.removeErrorMessage('agent');
                this.isAgentOverride = true;
                this.isAgentUpdated = false;
            }
         },
        permanentAddressChange() {
            // remove existing error message and changed true
            if (!this.isPermanentAddressChanged) this.isPermanentAddressChanged = true;
            this.removeErrorMessage('permanent');
        },
        mailingAddressChange() {
            // remove existing error message and changed true
            if (!this.isMailingAddressChanged) this.isMailingAddressChanged = true;
            this.removeErrorMessage('mailing');
        },
        loanoutAddressChange() {
            // remove existing error message and changed true
            if (!this.isLoanoutAddressChanged) this.isLoanoutAddressChanged = true;
            this.removeErrorMessage('loanout');
        },
        agentAddressChange() {
            // remove existing error message and changed true
            if (!this.isAgentAddressChanged) this.isAgentAddressChanged = true;
            this.removeErrorMessage('agent');
        },
        removeErrorMessage(section) {
            if (section === 'permanent') {
                if (this.error_main_generic) this.error_main_generic = '';
                if (this.error_main_address1) this.error_main_address1 = '';
                if (this.error_main_city) this.error_main_city = '';
                if (this.error_main_postal) this.error_main_postal = '';
                if (this.error_main_state) this.error_main_state = '';
            } else if (section === 'mailing') {
                if (this.error_mailing_generic) this.error_mailing_generic = '';
                if (this.error_mailing_address1) this.error_mailing_address1 = '';
                if (this.error_mailing_city) this.error_mailing_city = '';
                if (this.error_mailing_postal) this.error_mailing_postal = '';
                if (this.error_mailing_state) this.error_mailing_state = '';
            } else if (section === 'loanout') {
                if (this.error_loanout_generic) this.error_loanout_generic = '';
                if (this.error_loanout_address1) this.error_loanout_address1 = '';
                if (this.error_loanout_city) this.error_loanout_city = '';
                if (this.error_loanout_postal) this.error_loanout_postal = '';
                if (this.error_loanout_state) this.error_loanout_state = '';
            } else if (section === 'agent') {
                if (this.error_agent_generic) this.error_agent_generic = '';
                if (this.error_agent_address1) this.error_agent_address1 = '';
                if (this.error_agent_city) this.error_agent_city = '';
                if (this.error_agent_postal) this.error_agent_postal = '';
                if (this.error_agent_state) this.error_agent_state = '';
            }
        },
        verify(address1, address2, city, state, postal, country) {
            // actual verification function

            return new Promise(function (resolve, reject) {
                if (address1.length === 0) {
                    return;
                }
    
                let address = {
                    line1: address1
                };
                if (address2) {
                    address.line2 = address2;
                }
                if (city) {
                    address.city = city;
                }
                if (state) {
                    address.provinceOrState = state;
                }
                if (postal) {
                    address.postalOrZip = postal;
                }
                if (country) {
                    address.country = country.toLowerCase();
                }
                var xhr = new XMLHttpRequest();
                xhr.open(
                    'POST',
                    'https://api.postgrid.com/v1/addver/verifications?includeDetails=true',
                );
                xhr.setRequestHeader('Content-Type', 'application/json');
                if (postGridKey) {
                    xhr.setRequestHeader('X-API-KEY', postGridKey);
                }
                xhr.timeout = 15000;
                xhr.onload = function () {
                    var resp = JSON.parse(xhr.responseText);
                    if (xhr.status === 200) {
                        resolve(resp.data);
                    } else {
                        reject(resp);
                    }
                };
                // late response
                xhr.ontimeout = function (e) {
                    reject();
                };
                xhr.send(JSON.stringify({ address }));
            });
        },
        async verifyFields(address1, address2, city, state, postal, country, section) {
            if (!address1) {
                return false;
            }
            // we want to separate suite number and key into line 2
            // postgrid provide line 1 with suite number and key
            let line2CustomString = '';
            
            try {
                let stateObj;
                if (state) {
                    stateObj = this.states.find((element) => element.id == state);
                    state = stateObj.code;
                }
                if (country) country = country == 1 ? 'US' : 'CA';
                else country = stateObj.country_id == 1 ? 'US' : 'CA';

                let result = await this.verify(address1, address2, city, state, postal, country);
                if (result.line1) address1 = result.line1;

                if (result.zipPlus4) {
                    result.postalOrZip = result.postalOrZip
                        ? result.postalOrZip + '-' + result.zipPlus4
                        : result.zipPlus4;
                }
                if (result.urbanization) {
                    result.line2 = result.line2
                        ? result.line2 + ' URB ' + result.urbanization
                        : result.urbanization;
                }
                address2 = result.line2 ? result.line2 : '';
                if (result.details.suiteKey && result.details.suiteID) {
                    if (country == 1 || country.toUpperCase() == 'US') {
                        address1 = address1.split(result.details.suiteKey)[0];
                        line2CustomString = result.line2 ? result.line2 + ' ' + result.details.suiteKey + ' ' + result.details.suiteID : result.details.suiteKey + ' ' + result.details.suiteID;
                        address2 = line2CustomString;
                    }
                }
                if (result.city) city = result.city;
                if (result.provinceOrState) {
                    state = this.states.find((element) => element.code == result.provinceOrState.toUpperCase());
                    if (!state) result.status = 'falied';
                    else state = state.id;
                }
                if (result.postalOrZip) postal = result.postalOrZip;
                if (result.country) {
                    country = result.country.toUpperCase() == 'US' ? 1 : 2;
                }

                if (result.status === 'verified' || result.status === 'corrected') {
                    // insert data
                    if (section === 'permanent') {
                        this.employee.main_address1 = address1;
                        this.employee.main_address2 = address2;
                        this.employee.main_city = city;
                        this.employee.main_state_id = state;
                        this.employee.main_country_id = country;
                        this.employee.main_postal = postal;
                        if (result.status === 'corrected') this.isPermanentUpdated = true;
                    } else if (section === 'mailing') {
                        this.employee.mailing_address1 = address1;
                        this.employee.mailing_address2 = address2;
                        this.employee.mailing_city = city;
                        this.employee.mailing_state_id = state;
                        this.employee.mailing_country_id = country;
                        this.employee.mailing_postal = postal;
                        if (result.status === 'corrected') this.isMailingUpdated = true;
                    } else if (section === 'loanout') {
                        this.employee.loanout_address1 = address1;
                        this.employee.loanout_address2 = address2;
                        this.employee.loanout_city = city;
                        this.employee.loanout_state_id = state;
                        this.employee.loanout_country_id = country;
                        this.employee.loanout_postal = postal;
                        if (result.status === 'corrected') this.isLoanoutUpdated = true;
                    } else if (section === 'agent') {
                        this.employee.special_type_properties.agency_address1 = address1;
                        this.employee.special_type_properties.agency_address2 = address2;
                        this.employee.special_type_properties.agency_city = city;
                        this.employee.special_type_properties.agency_state_id = state;
                        this.employee.special_type_properties.agency_postal = postal;
                        if (result.status === 'corrected') this.isAgentUpdated = true;
                    }
                    return true;
                } else {
                    if (result.errors) {
                        // handle errors
                        if (section === 'permanent') {
                            if (result.errors.line1) this.error_main_address1 = result.errors.line1;
                            if (result.errors.city) this.error_main_city = result.errors.city;
                            if (result.errors.provinceOrState) this.error_main_state = result.errors.provinceOrState;
                            if (result.errors.postalOrZip) this.error_main_postal = result.errors.postalOrZip;
                            this.error_main_generic = 'Address may not be valid';
                        } else if (section === 'mailing') {
                            if (result.errors.line1) this.error_mailing_address1 = result.errors.line1;
                            if (result.errors.city) this.error_mailing_city = result.errors.city;
                            if (result.errors.provinceOrState) this.error_mailing_state = result.errors.provinceOrState;
                            if (result.errors.postalOrZip) this.error_mailing_postal = result.errors.postalOrZip;
                            this.error_mailing_generic = 'Address may not be valid';
                        } else if (section === 'loanout') {
                            if (result.errors.line1) this.error_loanout_address1 = result.errors.line1;
                            if (result.errors.city) this.error_loanout_city = result.errors.city;
                            if (result.errors.provinceOrState) this.error_loanout_state = result.errors.provinceOrState;
                            if (result.errors.postalOrZip) this.error_loanout_postal = result.errors.postalOrZip;
                            this.error_loanout_generic = 'Address may not be valid';
                        } else if (section === 'agent') {
                            if (result.errors.line1) this.error_agent_address1 = result.errors.line1;
                            if (result.errors.city) this.error_agent_city = result.errors.city;
                            if (result.errors.provinceOrState) this.error_agent_state = result.errors.provinceOrState;
                            if (result.errors.postalOrZip) this.error_agent_postal = result.errors.postalOrZip;
                            this.error_agent_generic = 'Address may not be valid';
                        }
                    }
                    return false;
                }
            } catch (err) {
                if (section === 'permanent') this.error_main_generic = 'Address may not be valid';
                else if (section === 'mailing') this.error_mailing_generic = 'Address may not be valid';
                else if (section === 'loanout') this.error_loanout_generic = 'Address may not be valid';
                else if (section === 'agent') this.error_agent_generic = 'Address may not be valid';
                return false;
            }
        },
        // Function to show/hide approval modal
        displayApprovalModal(hide) {
            if (hide) {
                this.approveModal = false;
            } else {
                this.approveModal = true;
            }
        },

        // Easy validation, e.g. if fields are required
        checkForm(form) {
            // we don't need to run this function to employee. we have another validate function for employee
            if (this.type === 'employee') return true;
            let errors = false;
            //  we need to add this code in checkform function to check whether I9 date field is error or not.
            if ( this.errors.list_a_exp || this.errors.list_b_exp || this.errors.list_c_exp ) errors = true;
            for (const ref in this.$refs) {
                let element = this.$refs[ref];

                if (Array.isArray(element)) {
                    element = element[0];
                }
                if (typeof element === 'undefined' || element === undefined || !element || !element.classList) {
                    continue;
                }
                // If custom field, highlight description, too
                let descElement;
                if (ref.match(/state_form_fields/)) {
                    descElement = this.$refs[`description.${ref}`];
                } else if (ref.match(/custom_form_fields/)) {
                    descElement = this.$refs['description.' + ref];
                } else if (ref.match(/canada_form_fields/)) {
                    descElement = this.$refs['description.' + ref];
                }

                if (descElement && Array.isArray(descElement)) {
                    descElement = descElement[0];
                } else if (typeof descElement === 'undefined' || descElement === undefined) {
                    descElement = false;
                }

                element.classList.remove('form-error2');  // Remove these errors as they are returned from API
                if (!element.required) {
                    continue;
                // Don't show errors to employees when employer fields are not completed
                } else if (this.type === 'employee' && ref.match(/custom_form_employer_fields/)) {
                    continue;
                }

                if (element.classList.contains('form-error')) {
                    errors = true;
                    // console.log(element.name)
                    if (descElement) descElement.classList.add('form-error');
                } else if (element.type.toLowerCase() === 'checkbox' && element.checked === false) {
                    errors = true;
                    element.classList.add('form-missing');
                    if (descElement) descElement.classList.add('form-missing');
                } else if (element.type.toLowerCase() === 'radio' && this.$refs[element.name] && Array.isArray(this.$refs[element.name]) && !this.$refs[element.name].find((el) => el.checked === true)) {
                    errors = true;
                    element.classList.add('form-missing');
                    if (descElement) descElement.classList.add('form-missing');
                } else if (element.value === '' || element.value === null) {
                    errors = true;
                    element.classList.add('form-missing');
                    // console.log(element.name)
                } else {
                    element.classList.remove('form-missing');
                    if (descElement) descElement.classList.remove('form-missing');
                }
                
            }
            // check component address data that are required. not working $refs in parent as normal.
            let main_address1 = document.getElementsByName("main_address1");
            let loanout_address1 = document.getElementsByName("loanout_address1");
            let agent_address1 = document.getElementsByName("agency_address1");

            if (main_address1.length > 0 && main_address1[0].required && !this.employee.main_address1) {
                errors = true;
                main_address1[0].classList.add('form-missing');
            }

            if (loanout_address1.length > 0 && loanout_address1[0].required && !this.employee.loanout_address1) {
                errors = true;
                loanout_address1[0].classList.add('form-missing');
            }

            if (agent_address1.length > 0 && agent_address1[0].required && !this.employee.special_type_properties.agency_address1) {
                errors = true;
                agent_address1[0].classList.add('form-missing');
            }

            const ddCheck = this.checkDirectDeposit();
            if (ddCheck.status === false) errors = true;

            const passwordResult = this.checkPassword();
            if (passwordResult.status === false) errors = true;

            if (this.isCaEddRequired) {
                const caEddCheck = this.verifyCaEddNumber(this.employee.loanout_ca_edd);
                if (caEddCheck === false) {
                    errors = true;
                }
            }

            if (errors === true) {
                this.createDialog({ "title": "Warning", "body": 'Please check highlighted fields before submitting.<br />', "buttonNo": false, "buttonYesLabel": "OK"  });
                if (this.firstErrorPanel) {
                    this.setFocus(this.firstErrorPanel);
                }
                return false;
            } else {
                return true;
            }
        },

        checkArrayFields(fields=null) {
            if (!fields || !Array.isArray(fields)) {
                return false;
            }

            let messages = '';

            for (const fieldObject of fields) {
                const field = fieldObject.field;
                const fieldName = fieldObject.name;
                const element = this.$refs[field] || undefined;

                if (typeof element === 'undefined' || element === undefined) {
                    continue;
                } else { 
                    element.classList.remove('form-error2');  // Remove these errors as they are returned from API
                }

                if (element.classList.contains('form-error')) {
                    messages += 'Please correct ' + fieldName + ' before submitting.<br />'
                } else if (element.type.toLowerCase() === 'checkbox' && element.checked === false) {
                    element.classList.add('form-missing');
                    messages += 'Please check ' + fieldName + ' before submitting.<br />'
                } else if (element.value === '' || element.value === null) {
                    element.classList.add('form-missing');
                    messages += 'Please add ' + fieldName + ' before submitting.<br />'
                } else {
                    element.classList.remove('form-missing');
                }
            }

            return messages;
        },

        checkAcknowledgementStep() {
            if (this.isAcknowledged()) {
                this.employeeApprovalStep = 2;
            }
        },

        resetFormErrors(scope) {
            $("#ack").removeClass("form-error");
            $.each(scope, function (index, value) {
                $(value).filter(".form-error").each(function(ind, field){
                    $(field).removeClass("form-error");
                });

                $(value).filter(".form-error2").each(function(ind, field){
                    $(field).removeClass("form-error2");
                });

                $(value).filter(".form-missing").each(function(ind, field){
                    $(field).removeClass("form-missing");
                });
            });
        },

        addFormErrors(scope) {
            $.each(scope, function (index, value) {
                $(value).filter("[required]:visible").each(function(ind, field){
                    if ($(field).val() == "") {
                        $(field).addClass("form-missing");
                    } else {
                        $(field).removeClass("form-missing");
                    }
                });
            });
        },

        checkI9Fields(i9Fields) {
            let type = ''
            let message = '';
            let fatalError = false;
            let status = false;

            if (i9Fields) {
                type = 'standalone';
            } else {
                i9Fields = this.assignment;
                type = this.type;
            }

            // Check if List A or Lists B/C are complete.
            if (type === 'employer' || type === 'standalone') {
                if (! i9Fields.list_a_type_id && ! i9Fields.list_b_type_id && ! i9Fields.list_c_type_id) {
                    message = 'Please complete List A <u>OR</u> Lists B & C fields and review the I-9 Verification before submitting.<br />';
                }

                if (i9Fields.list_a_type_id && (! i9Fields.list_a_number || ! i9Fields.list_a_exp )) {
                    if (!i9Fields.list_a_number) this.errors.list_a_number = true;
                    if (!i9Fields.list_a_exp) this.errors.list_a_exp = true;
                    message = 'Please complete List A of I-9 Verification before submitting.<br />';
                }
                if ((i9Fields.list_b_type_id || i9Fields.list_c_type_id) && (! i9Fields.list_b_number || ! i9Fields.list_b_exp || ! i9Fields.list_c_number || ! i9Fields.list_c_exp)) {
                    if (!i9Fields.list_b_type_id) this.errors.list_b_type_id = true;
                    if (!i9Fields.list_c_type_id) this.errors.list_c_type_id = true;
                    if (!i9Fields.list_b_number) this.errors.list_b_number = true;
                    if (!i9Fields.list_c_number) this.errors.list_c_number = true;
                    if (!i9Fields.list_b_exp) this.errors.list_b_exp = true;
                    if (!i9Fields.list_c_exp) this.errors.list_c_exp = true;
                    message = 'Please complete List B & C of I-9 Verification before submitting.<br />';
                }
            } else {
                if (i9Fields.ee_list_a_type_id && (! i9Fields.ee_list_a_number || ! i9Fields.ee_list_a_exp )) {
                    if (!i9Fields.ee_list_a_number) this.errors.ee_list_a_number = true;
                    if (!i9Fields.ee_list_a_exp) this.errors.ee_list_a_exp = true;
                    message = 'Please complete List A of I-9 Verification before submitting.<br /><br />';
                }
                if ((i9Fields.ee_list_b_type_id || i9Fields.ee_list_c_type_id) && (! i9Fields.ee_list_b_number || ! i9Fields.ee_list_b_exp || ! i9Fields.ee_list_c_number || ! i9Fields.ee_list_c_exp)) {
                    if (!i9Fields.ee_list_b_type_id) this.errors.ee_list_b_type_id = true;
                    if (!i9Fields.ee_list_c_type_id) this.errors.ee_list_c_type_id = true;
                    if (!i9Fields.ee_list_b_number) this.errors.ee_list_b_number = true;
                    if (!i9Fields.ee_list_c_number) this.errors.ee_list_c_number = true;
                    if (!i9Fields.ee_list_b_exp) this.errors.ee_list_b_exp = true;
                    if (!i9Fields.ee_list_c_exp) this.errors.ee_list_c_exp = true;
                    message = 'Please complete List B & C of I-9 Verification before submitting.<br /><br />';
                }

                // Prevent both sections from being completed
                if (i9Fields.ee_list_a_type_id && (i9Fields.ee_list_b_type_id || i9Fields.ee_list_c_type_id)) {
                    message += 'On the I-9 section, you have entered both a List A document along with List B/C document(s).  Please clear either your List A information <u>OR</u> your List B and List C information.<br /><br />';
                    fatalError = true;
                }
            }

            if (message) {
                // Failed I9
                return { status: status, message: message, fatal: fatalError };
            } else {
                // Passed
                status = true;
                return { status: status, message: message, fatal: fatalError };
            }
        },

        verifyI9(event) {
            // Check I9 if blank, and if not, then mark I9 as verified by putting userId into the assignment
            let verified = false;
            let message = '';
            let fatalError = false;
            let status = false;

            if (((this.assignment.loanout_status === true || parseInt(this.assignment.loanout_status) === 1) && this.enforceLoanoutI9 !== true) || (this.isForeign && !this.isSsnNeeded)) {
                status = true;
                return { status: status, message: message };
            }

            verified = this.i9_verified;

            if (this.type === 'employee') {
                const result = this.checkI9Fields();
                if (result.status === true) {
                    status = true;
                } else {
                    message = result.message;
                    fatalError = result.fatal || false;
                }
            } else if (this.type === 'employer' && verified) {
                const result = this.checkI9Fields();
                if (result.status === true) {
                    status = true;
                } else {
                    message = result.message;
                    fatalError = result.fatal || false;
                }
            } else if (this.type === 'employer' && this.assignment.is_rehire) {
                const result = this.checkI9Fields();
                if (result.status === true) {
                    status = true;
                } else {
                    message = result.message;
                    fatalError = result.fatal || false;
                }
            } else if (this.type === 'employer') {
                message = 'You have not verified the I-9 by checking the box on the form.<br >';
            }

            if (message) {
                // Failed
                this.assignment.i9_verifier_id = null;
                return { status: status, message: message, fatal: fatalError };
            } else {
                // Passed
                status = true;
                if (! this.assignment.i9_verifier_id) this.assignment.i9_verifier_id = this.employer.id;
                return { status: status, message: message, fatal: fatalError };
            }
        },

        // Copies employee-entered I9 data into employer fields to comply with DHS rules
        importEeI9() {
            const i9Fields = [ 'list_a_type', 'list_a_type_id', 'list_a_number', 'list_a_auth', 'list_a_exp', 'list_b_type', 'list_b_type_id', 'list_b_number', 'list_b_auth', 'list_b_exp', 'list_c_type', 'list_c_type_id', 'list_c_number', 'list_c_auth', 'list_c_exp' ];

            i9Fields.forEach((employerField) => {
                const employeeField = 'ee_' + employerField;
                if (this.assignment[employeeField]) {
                    this.readonlyI9 = false;
                    this.assignment[employerField] = this.assignment[employeeField];
                    // we changed to use date-field component instead of using html input tag directly. we got css error here. so I changed the way to manage css I9 date field.
                    if (employerField == 'list_a_exp' || employerField == 'list_b_exp' || employerField == 'list_c_exp'){
                        this.errors[employerField] = false;
                        this.changed[employerField] = true;
                    } else {
                        this.highlightChangeI9({ target: this.$refs['assignment.' + employerField] });
                    }
                }
            });
        },

        checkDirectDeposit() {
            // Skip if employer
            if (this.type === 'employer') return { status: true, message: '' };

            // Reset
            $("#dd_acknowledge").removeClass("form-missing");
            var scope = [ "#ddForm input", "#ddForm select" ];
            this.resetFormErrors(scope);
            let message = '';

            if (this.directDeposit === true && this.assignment.dd_status > 0) {
                if (this.assignment.dd_bank_account_1 !== this.assignment.dd_bank_confirm_1) {
                    message += 'Please double check your Direct Deposit bank #1 account number. <br />';
                    $("input[name='dd_bank_account_1']").addClass('form-missing');
                }
                if (this.assignment.dd_status > 1 && this.assignment.dd_bank_account_2 && this.assignment.dd_bank_account_2 !== this.assignment.dd_bank_confirm_2) {
                    message += 'Please double check your Direct Deposit bank #2 account number. <br />';
                    $("input[name='dd_bank_account_2']").addClass('form-missing');
                }

                this.requiredDD1.map(data => {
                    if (this.$refs[data.field].value === '') {
                        message += 'Please add your ' + data.name + ' <br />';
                        this.$refs[data.field].classList.add('form-missing')
                    }
                });

                if (this.assignment.dd_status > 1 && this.currentStep !== 'DirectDeposit1') {
                    this.requiredDD2.map(data => {
                        if (this.$refs[data.field].value === '') {
                            message += 'Please add your ' + data.name + ' <br />';
                            this.$refs[data.field].classList.add('form-missing')
                        }
                    });
                }

                if (message) {
                    return { status: false, message: message };
                } else {
                    this.validateDdPercentage();
                    return { status: true, message: message };
                }
            } else {
                this.employee.papercheck_optin = true;
                return { status: true, message: message };
            }
        },

        checkPassword() {
            // Skip if already registered
            if (this.type === 'employer' || !this.isNewUser) return { status: true, message: '' };

            // Reset
            if (this.$refs['password_alert']) this.$refs['password_alert'].classList.add('hide');
            if (this.$refs['shortPassword_alert']) this.$refs['shortPassword_alert'].classList.add('hide');
            if (this.$refs['complexPassword_alert']) this.$refs['complexPassword_alert'].classList.add('hide');
            if (this.$refs['repeatPassword_alert']) this.$refs['repeatPassword_alert'].classList.add('hide');
            if (this.$refs['repeatPassword']) this.$refs['repeatPassword'].classList.remove('form-missing');
            let message = '';

            if (!this.employee.password && this.$refs['password_alert']) this.$refs['password_alert'].classList.remove('hide');

            // Validate password strength
            const containsUpper = this.employee.password.match(/[A-Z]/);
            const containsLower = this.employee.password.match(/[a-z]/);
            const containsNumber = this.employee.password.match(/[0-9]/);
            const containsSpecial = true; // Better match browser-generated passwords this.employee.password.match(/[\W_]/);

            if (this.employee.password.length >= 24) {
                // Allow any combo
            } else if (this.employee.password.length >= 8 && containsUpper && containsLower && containsNumber && containsSpecial) {
                // Continue
            } else if (this.employee.password.length < 8) {
                message += 'Please choose a longer password.<br />';
                setTimeout(() => {
                    if (this.$refs['employee.password']) this.$refs['employee.password'].classList.remove('form-change');
                    if (this.$refs['employee.password']) this.$refs['employee.password'].classList.add('form-missing');
                    if (this.$refs['shortPassword_alert']) this.$refs['shortPassword_alert'].classList.remove('hide');
                }, 200);
            } else {
                message += 'Please double check your password is complex enough.<br />';
                setTimeout(() => {
                    if (this.$refs['employee.password']) this.$refs['employee.password'].classList.remove('form-change');
                    if (this.$refs['employee.password']) this.$refs['employee.password'].classList.add('form-missing');
                    if (this.$refs['complexPassword_alert']) this.$refs['complexPassword_alert'].classList.remove('hide');
                }, 200);
            }

            if (message) {
                return { status: false, message: message };
            }
            // Good password.  Now confirm
            if (this.employee.password && this.employee.password !== this.repeatPassword) {
                message += 'Your passwords do not match.<br />';
                setTimeout(() => {
                    if (this.$refs['repeatPassword']) this.$refs['repeatPassword'].classList.remove('form-change');
                    if (this.$refs['repeatPassword']) this.$refs['repeatPassword'].classList.add('form-missing');
                    if (this.$refs['repeatPassword_alert']) this.$refs['repeatPassword_alert'].classList.remove('hide');
                }, 200);
                return { status: false, message: message };
            } else {
                return { status: true, message: message };
            }
        },

        checkCertification() {
            // Skip if employer or if employee opted for later
            if (this.type === 'employer' || this.certPanel === false || this.isCertified) return { status: true, message: '' };

            let message = '';

            if (this.isCertificationRequired === true && !this.certDocModal) {
                message += 'Please select a Workplace Certification option.';
            } else {
                if (this.isCertificationRequired === true && !this.assignment.certification_type_id) {
                    message += 'Please double check you have selected a workplace certification type. <br />';
                }
                if (this.isCertificationRequired === true && !this.localFormatCertificationDate) {
                    message += 'Please enter a completion date for your certification. <br />';
                }
                if (this.isCertificationRequired === true && this.errors.certification_completion_date === true) {
                    message += 'Please fix a completion date for your certification. <br />';
                }
                if (this.isCertificationRequired === true && !this.certDocs.length) {
                    message += 'Please upload a completion certificate. <br />';
                }
            }

            if (message) {
                return { status: false, message: message };
            } else {
                return { status: true, message: message };
            }
        },

        // used to set timecard header after loading employee
        updateAssignment(assignment) {
            let keys = Object.keys(assignment);
            for (let i = 0; i < keys.length; i++) {
                let currKey = keys[i];
                if (assignment[currKey]) {
                    if (currKey === 'custom_forms') {
                        if (typeof assignment.custom_forms === 'string' && this.isJson(assignment.custom_forms)) this.assignment.custom_forms = JSON.parse (assignment.custom_forms);
                        else this.assignment.custom_forms = assignment.custom_forms;
                        if (this.assignment.custom_forms.length > 0) {
                            const formIds = '?id__in=' + this.assignment.custom_forms.join(',');
                            this.oasisApi.get(this.endpoints.customDocuments + formIds)
                                .then(response => {
                                    if (response.status === 200 && response.data) {
                                        this.customDocuments = response.data.results
                                    }
                                })
                                .catch(error => {
                                    console.log(error)
                                });
                        }
                    } else if (currKey === 'custom_form_fields' && typeof assignment.custom_form_fields === 'string' && this.isJson(assignment.custom_form_fields)) {
                        this.assignment.custom_form_fields = JSON.parse (assignment.custom_form_fields);
                    } else if (currKey === 'custom_form_employer_fields' && typeof assignment.custom_form_employer_fields === 'string' && this.isJson(assignment.custom_form_employer_fields)) {
                        this.assignment.custom_form_employer_fields = JSON.parse (assignment.custom_form_employer_fields);
                    } else if (currKey === 'dd_bank_account_1') {
                        this.assignment.dd_bank_account_1 = assignment.dd_bank_account_1;
                        this.assignment.dd_bank_confirm_1 = assignment.dd_bank_account_1;
                    } else if (currKey === 'dd_bank_account_2') {
                        this.assignment.dd_bank_account_2 = assignment.dd_bank_account_2;
                        this.assignment.dd_bank_confirm_2 = assignment.dd_bank_account_2;
                    } else if (currKey === 'i9_verifier_id' && !isNaN(assignment[currKey])) {
                        this.assignment.i9_verifier_id = assignment.i9_verifier_id;
                        this.i9_verified = true;
                        this.readonlyI9 = true;
                    } else {
                        this.assignment[keys[i]] = assignment[keys[i]];
                    }
                }
            }

            if (assignment.metadata) {
                if (assignment.metadata.finished) {
                    this.finished = assignment.metadata.finished;
                }
                if (assignment.metadata.failed) {
                    this.failed = assignment.metadata.failed;
                }

                if (assignment.metadata.currentStep) {
                    if (assignment.metadata.currentStep.match(/Approv/)) {
                        this.currentStep = 'Approval0';
                        const ind = this.finished.indexOf('Approval0');
                        if (ind >= 0) this.finished.splice(ind);
                    } else {
                        this.currentStep = assignment.metadata.currentStep;
                    }
                }
            }

            this.getAssets(assignment);
            this.getHistory();

            // Load Kit Rental
            if ((this.assignment.kit_rental && this.assignment.kit_rental > 0) || (this.assignment.kit_rental_tax && this.assignment.kit_rental_tax > 0)) {
                this.loadKitInventory();
            }
            if (this.assignment.start_date) this.convertStartDate = DateTime.fromFormat(this.assignment.start_date, 'MM/dd/yyyy').toFormat(this.format);
            if (this.assignment.term_date) this.convertTermDate = DateTime.fromFormat(this.assignment.term_date, 'MM/dd/yyyy').toFormat(this.format);
        },

        // Retreive employee data based on an assignment under that entity (and its parents).
        updateEmployee(employee) {
            let keys = Object.keys(employee);
            for (let i = 0; i < keys.length; i++) {
                let currKey = keys[i];
                if (employee[currKey]) {
                    // For autocomplete, need special ways to assign values
                    if (currKey === 'main_state') {
                        this.newMainState = { "name": employee.main_state, "id": employee.main_state_id };
                        this.employee[keys[i]] = employee[keys[i]];
                    } else if (currKey === 'mailing_state') {
                        this.newMailingState = { "name": employee.mailing_state, "id": employee.mailing_state_id };
                        this.employee[keys[i]] = employee[keys[i]];
                    } else if (currKey === 'loanout_state') {
                        this.newLoanoutState = { "name": employee.loanout_state, "id": employee.loanout_state_id };
                        this.employee[keys[i]] = employee[keys[i]];
                    } else if (currKey === 'special_type_properties' && typeof employee.special_type_properties === 'string' && this.isJson(employee.special_type_properties)) {
                        this.employee.special_type_properties = JSON.parse(employee.special_type_properties);
                    } else if (currKey === 'state_forms' && typeof employee.state_forms === 'string' && this.isJson(employee.state_forms)) {
                        this.employee.state_forms = JSON.parse (employee.state_forms);
                    } else if (currKey === 'state_form_fields' && typeof employee.state_form_fields === 'string' && this.isJson(employee.state_form_fields)) {
                        this.employee.state_form_fields = JSON.parse (employee.state_form_fields);
                    } else if (currKey === 'previousDD' && typeof employee.previousDD === 'string' && this.isJson(employee.previousDD)) {
                        this.employee.previousDD = JSON.parse(employee.previousDD);
                        // Mark as uploaded
                        if (employee.previousDD && employee.previousDD.asset_id) {
                            this.uploadedDdAsset = true;
                        }
                    } else if (currKey === 'loanout_states_registered'){
                        // if has loanout_states_registered and If loanout_states_registered is Json, load this data, If not(existing messed up string data), will ignore
                        if (typeof employee.loanout_states_registered === 'string' && this.isJson(employee.loanout_states_registered)) {
                            this.employee.loanout_states_registered = JSON.parse(employee.loanout_states_registered);
                        }
                    } else if (currKey === 'metadata' && typeof employee.metadata === 'string' && this.isJson(employee.metadata)) {
                        this.employee.metadata = JSON.parse(employee.metadata);
                    } else if (currKey === 'loanout_type_id') {
                        this.employee[currKey] = employee[currKey];
                        this.changeEntityType(true);
                    } else if (currKey === 'papercheck_optin') {
                        this.employee[currKey] = employee[currKey] > 0 ? true : false;
                    } else {
                        this.employee[currKey] = employee[currKey];
                    }
                }
            }

            // for older starts that do not have this field in the metadata
            if (!this.employee.metadata.hasOwnProperty('residentState')) this.employee.metadata.residentState = {};

            // Set allowances model
            if (employee.exemptions == -1) this.w4.exempt = true;
            if (employee.exemptions_state == -1) this.w4.exempt_state = true;
            this.isNewUser = employee.password === true ? false : true;
            if (this.employee.birth_date) this.localFormatBirthDate = DateTime.fromFormat(this.employee.birth_date, 'MM/dd/yyyy').toFormat(this.format);

            // Go to the first erroneous step
            if (this.failedErrorPanel) {
                this.currentStep = this.firstErrorPanel;
            }

            // Show the current panel
            if (this.currentStep) {
                setTimeout(() => {
                    if (this.currentStep !== 'Start') {
                        $('#panelStart').collapse('hide');
                    }
                    // $(`#panel${this.currentStep}`).collapse('show');
                    this.setFocus();
                    this.checkStep();
                }, 100);
            }
        },

        // Autocomplete for State selection
        updateMainState(value){
            this.employee.main_state = value.code;
            this.employee.main_state_id = value.id;
            $("input[name='main_state_id']").addClass('form-change');
        },

        updateMailingState(value){
            this.employee.mailing_state = value.code;
            this.employee.mailing_state_id = value.id;
            $("input[name='mailing_state_id']").addClass('form-change');
        },

        updateLoanoutState(value){
            this.employee.loanout_state = value.code;
            this.employee.loanout_state_id = value.id;
            $("input[name='loanout_state_id']").addClass('form-change');
        },

        // Check to see if a new location is being added else update location settings
        updateSignature(value){
            if (this.type == 'employer') {
                this.employer.signature = value;
                // alert ('signed employer');
            } else if (this.type == 'employee') {
                this.employee.signature = value;
                // alert ('signed employee');
            } else {
                // alert ('No sign');
                // console.log ("No Data Type");
            }

            // console.log ("Done sig");
            return true;
        },

        async checkAllSteps() {
            // console.log('Checking all steps')
            let panels = document.getElementsByClassName('panel-collapse');
            for (const i in panels) {
                const panel = panels[i];
                const step = (panels[i].id || '').replace(/^panel/, '');
                if (typeof panel !== 'object' || step.match('Approval')) continue;
                let validate = await this.checkStep(panel);

                if (validate.errors === true) {
                    const message = validate.message || 'Please check highlighted fields in the sections marked with an "X" before submitting.<br />';
                    this.createDialog({ "title": "Warning", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    this.setCurrentStep(step)
                    return false;
                }
            }
            return true;
        },

        async checkStep(stepToCheck) {
            const step = stepToCheck || this.$refs['panel' + this.currentStep]
            let result = { errors: false, message: '' };
            if (!step) return result;
            // console.log('Step' , step, stepToCheck, this.currentStep)
            let elements = (step.querySelectorAll('input, select') || []);
            for (const i in elements) {
                let element = elements[i];
                let ref = element.name || ''
                if (Array.isArray(element)) {
                    element = element[0];
                }

                if (typeof element === 'undefined' || element === undefined || !element.classList) {
                    // console.log('Skipping' , element);
                    continue;
                }

                // If custom field, highlight description, too
                let descElement = this.$refs[`description.${ref}`];
                if (typeof descElement === 'undefined' || descElement === undefined) {
                    descElement = false;
                } else if (descElement && Array.isArray(descElement)) {
                    descElement = descElement[0];
                }

                element.classList.remove('form-error2');  // Remove these errors as they are returned from API
                if (!element.required) {
                    continue;
                // Don't show errors to employees when employer fields are not completed
                } else if (this.type === 'employee' && ref.match(/custom_form_employer_fields/)) {
                    continue;
                }

                if (element.classList.contains('form-error')) {
                    result.errors = true;
                    result.element = element;
                    // console.log(element.name)
                    if (descElement) descElement.classList.add('form-error');
                } else if (element.type.toLowerCase() === 'checkbox' && element.checked === false) {
                    result.errors = true;
                    result.element = element;
                    element.classList.add('form-missing');
                    if (descElement) descElement.classList.add('form-missing');
                } else if (element.type.toLowerCase() === 'radio' && this.$refs[element.name] && Array.isArray(this.$refs[element.name]) && !this.$refs[element.name].find((el) => el.checked === true)) {
                    result.errors = true;
                    result.element = element;
                    element.classList.add('form-missing');
                    if (descElement) descElement.classList.add('form-missing');
                } else if (element.type.toLowerCase() === 'radio' && this.$refs[element.name]) {
                    // checking using the DOM
                    let node = `input[name="${element.name}"]:checked`
                    if (!document.querySelector(node)) {
                        result.errors = true;
                        result.element = element;
                        element.classList.add('form-missing');
                        if (descElement) descElement.classList.add('form-missing');
                    }
                } else if (element.value === '' || element.value === null) {
                    result.errors = true;
                    result.element = element;
                    element.classList.add('form-missing');
                    // console.log(element.name)
                } else if (element.classList.contains('form-missing') && (ref === 'password' || ref ==='repeatPassword')) {
                    // added password error case
                    result.errors = true;
                    result.element = element;
                    result.message = "Please review password requirements and update to proceed."
                } else if (element.classList.contains('form-missing')) {
                    result.errors = true;
                    result.element = element;
                } else {
                    element.classList.remove('form-missing');
                    if (descElement) descElement.classList.remove('form-missing');
                }
            }

            // check basic form first, If have some issues, return.
            if (result.errors) {
                // console.log('Errors', result);
                return result;
            }

            // Check I9
            if (this.currentStep === 'EmploymentAuthorization') {
                const i9Result = (this.checkI9Fields() || {});
                if (i9Result.status === false) {
                    result.errors = true;
                    result.message = i9Result.message;
                }
                if ( this.errors.ee_list_a_exp || this.errors.ee_list_b_exp || this.errors.ee_list_c_exp ) result.errors = true;
            } else if (this.currentStep === 'EmployeeCertification') {
                const certResult = (this.checkCertification() || {});
                if (certResult.status === false) {
                    result.errors = true;
                    result.message = certResult.message;
                }
            } else if (this.currentStep === 'DirectDeposit1' || this.currentStep === 'DirectDeposit2') {
                const ddResult = (this.checkDirectDeposit() || {});
                if (ddResult.status === false) {
                    result.errors = true;
                    result.message = ddResult.message;
                }
            } else if (this.currentStep === 'DirectDeposit3') {
                if (this.uploadedDdAsset !== true) {
                    result.errors = true;
                    result.message = 'Please upload a voided check or deposit slip to activate direct deposit.<br />' 
                }
            } else if (this.currentStep === 'Approval1') {
                if (!this.isAcknowledged()) {
                    result.errors = true;
                    result.message = 'Please check off all acknowledgement boxes';
                }
            } else if (this.currentStep === 'Approval2') {
                if (!this.isSigned) {
                    result.errors = true;
                    result.message = 'Please Sign';
                }
            } else if (this.currentStep === 'Address' && addressValidationFlag === 'true') {
                // check address
                let permanentRes = true;
                if (this.error_main_generic) permanentRes = false;
                if (this.isPermanentUpdated) this.isPermanentUpdated = false;

                if (this.isPermanentAddressChanged && this.employee.main_state_id != 66 && permanentRes && !this.isPermanentOverride) {
                    permanentRes = await this.verifyFields(this.employee.main_address1, this.employee.main_address2, this.employee.main_city, this.employee.main_state_id, this.employee.main_postal, this.employee.main_country_id, 'permanent');
                    if (permanentRes) this.isPermanentAddressChanged = false;
                }
                if (!permanentRes) {
                    result.errors = true;
                    result.message = 'Please check address fields before submitting';
                }
            } else if (this.currentStep === 'MailingAddress' && addressValidationFlag === 'true') {
                let mailingRes = true;
    
                if (this.error_mailing_generic) mailingRes = false;
                if (this.isMailingUpdated) this.isMailingUpdated = false;

                if (this.isMailingAddressChanged && this.employee.mailing_state_id != 66 && mailingRes && !this.isMailingOverride) {
                    if (this.employee.mailing_address1 || this.employee.mailing_address2 || this.employee.mailing_city || this.employee.mailing_state_id || this.employee.mailing_postal || this.employee.mailing_country_id) {
                        // mailing is not required fields. so If there is a certain value in mailing, validation will be ran, otherwise, skip it.
                        mailingRes = await this.verifyFields(this.employee.mailing_address1, this.employee.mailing_address2, this.employee.mailing_city, this.employee.mailing_state_id, this.employee.mailing_postal, this.employee.mailing_country_id, 'mailing');
                    }
                    if (mailingRes) this.isMailingAddressChanged = false;
                }
    
                if (!mailingRes) {
                    result.errors = true;
                    result.message = 'Please check address fields before submitting';
                }
            } else if (this.currentStep === 'Loanout' && this.assignment.loanout_status == 1) {
                if (this.isMissingStatesRegistered) {
                    result.errors = true;
                    result.message = 'Please select at least one state where your loanout is registered.';
                }
    
                if (addressValidationFlag === 'true') {
                    let loanoutRes = true;

                    if (this.error_loanout_generic) loanoutRes = false;
                    if (this.isLoanoutUpdated) this.isLoanoutUpdated = false;
        
                    if (this.isLoanoutAddressChanged && this.employee.loanout_state_id != 66 && loanoutRes && !this.isLoanoutOverride) {
                        loanoutRes = await this.verifyFields(this.employee.loanout_address1, this.employee.loanout_address2, this.employee.loanout_city, this.employee.loanout_state_id, this.employee.loanout_postal, this.employee.loanout_country_id, 'loanout');
                        if (loanoutRes) this.isLoanoutAddressChanged = false;
                    }
        
                    if (!loanoutRes) {
                        result.errors = true;
                        result.message = 'Please check address fields before submitting';
                    }
                }
            } else if (this.currentStep === 'Agent' && addressValidationFlag === 'true' && this.employee.special_type == 1) {
                let agentRes = true;

                if (this.error_agent_generic) agentRes = false;
                if (this.isAgentUpdated) this.isAgentUpdated = false;
    
                if (this.isAgentAddressChanged && this.employee.special_type_properties.agency_state_id != 66 && agentRes && !this.isAgentOverride) {
                    agentRes = await this.verifyFields(this.employee.special_type_properties.agency_address1, this.employee.special_type_properties.agency_address2, this.employee.special_type_properties.agency_city, this.employee.special_type_properties.agency_state_id, this.employee.special_type_properties.agency_postal, '', 'agent');
                    if (agentRes) this.isAgentAddressChanged = false;
                }
    
                if (!agentRes) {
                    result.errors = true;
                    result.message = 'Please check address fields before submitting';
                }
            }

            // console.log(this.currentStep, result);
            return result;
        },

        async previewStart() {
            if (!this.employeeStartLink) await this.getStartLink();
            this.viewStart();
        },

        viewStart() {
            this.viewerModal = true;
        },

        viewStartNewWindow() {
            window.open(this.employeeStartLink, '_blank');
        },
        
        downloadStart() {
            const link = (this.employeeStartLink || '').replace(/\/view\//, '/download/');
            window.open(link, '_blank');
        },

        // Check to see if the form is filled out prior to signing
        async approvalCheck() {
            // Check form
            // Check non-I9 stuff first
            if (this.checkForm() === false) {
                return false;
            }

            // Now check I9
            const verify = this.verifyI9();
            if (verify.status === false) {
                this.createDialog({
                    "title": "Warning",
                    "body": verify.message,
                    "buttonNoLabel": "Fix I-9",
                    "buttonYesLabel": "Approve without Verifying I-9",
                    "buttonYesAction": function () { app.displayApprovalModal(); },
                    "buttonYes": verify.fatal ? false : function () { app.updateTimecard(response.data); }
                });
            } else {
                if (this.type === 'employee') {
                    await this.getStartLink();
                } else {
                    this.approveModal = true;
                }
            }
        },

        // This is the button that checks for the digital signature
        approveStart(options) {
            if (! options) {
                options = {};
                options.approve = true;
            }

            if (this.type === 'employee' && ! this.employee.signature) {
                this.createDialog({ "title": "Warning", "body": "Please sign above first.", "buttonNo": false, "buttonYesLabel": "OK" });
            } else if (this.type === 'employer' && ! this.employer.signature) {
                this.createDialog({ "title": "Warning", "body": "Please sign above first.", "buttonNo": false, "buttonYesLabel": "OK" });
            // This test is a bit backwards. We want a false result to continue as a true means a checkbox is unchecked.
            } else if (Object.values(this.acknowledge).includes(false) === true) {
                this.createDialog({ "title": "Warning", "body": "Please check the acknowledgements to continue.", "buttonNo": false, "buttonYesLabel": "OK" });
                $("#ack").addClass("form-error");
                if (this.currentStep !== 'Approval1') this.setCurrentStep('Approval1');
            } else {
                this.approveModal=false;
                if (this.everifyEligible) {
                    this.createDialog({ "title": "Notice", "body": "Information sent to USCIS for E-Verify. Updates will be available on your dashboard in a few minutes.", "buttonNo": false, "buttonYesLabel": "OK" });
                }
                this.updateStart(options);
            }
        },

        // Allows for the bypassing of normal approval process.
        approveStartFinal() {
            let options = { "approve": true, "final": true };
            this.approveStart(options);
        },

        // Allows the approval of I9s only
        approveI9() {
            let options = { "approve": false, "final": false };
            this.approveStart(options);
        },

        // In-flight guard: dedupe concurrent saves. The step auto-save
        // (setCurrentStep) and the explicit approve/save (approveStart) can fire
        // updateStart twice at nearly the same instant, which sent two identical
        // PATCHes and caused an InnoDB deadlock. Run at most one save at a time;
        // drop any overlapping call.
        async updateStart(options) {
            if (this._updateInFlight) return false;
            this._updateInFlight = true;
            try {
                return await this._updateStartImpl(options);
            } finally {
                this._updateInFlight = false;
            }
        },

        // Actual saving of form.  Do not call directly without checking form first.
        async _updateStartImpl(options) {
            if (this.checkForm() === false) {
                // console.log('Failed checking form. Not saving.');
                return false;
            }

            // Prevent saving with a bad password
            const passwordResult = this.checkPassword();
            if (passwordResult.status === false) {
                // console.log('No password. Not saving.');
                return;
            }

            let hideDialog = options && options.hideDialog === true;
            let hideLoader = options && options.hideLoader === true;

            // check address form
            if (addressValidationFlag === 'true' && await this.checkAddressForm(hideDialog) === false) {
                return false;
            }
            this.approveModal = false;
            let employeeId = this.employee.id;
            let data = {};

            if (this.isWorkPlaceChanged && ! await this.addCertification(true)) {
                if (this.type === 'employer' ) return false;
            }

            if (employeeId) {
                var type = 'patch';
                let patchData = {}, assignmentPatchData = {}, i9PatchData = {}, certPatchData = {}, customPatchData = {}, customEmployerPatchData = {}, agentPatchData = {}, ddPatchData = {}, kitPatchData = {}, canadaPatchData = {};
                $("#employeeForm .form-change").each(function(ind,el) { patchData[el.name] = el.value });
                $("#job1Form .form-change").each(function(ind,el) { assignmentPatchData[el.name] = el.value });
                // Add loanout states registered
                if (this.assignment.hasOwnProperty('loanout_status') && this.assignment.loanout_status) {
                    patchData.loanout_states_registered = JSON.stringify(this.employee.loanout_states_registered);
                }
                if (patchData.birth_date) {
                    let tempDate = DateTime.fromFormat(this.localFormatBirthDate, this.format).toFormat('MM/dd/yyyy');
                    patchData.birth_date = tempDate;
                }
                // $("#customForm .form-change").each(function(ind,el) { customPatchData[el.name] = el.value });
                customPatchData = this.assignment.custom_form_fields;
                canadaPatchData = this.assignment.canada_form_fields;
                customEmployerPatchData = (this.type === 'employer') ? this.assignment.custom_form_employer_fields : null;
                kitPatchData = this.kitInventory || null;
                // Add dues
                assignmentPatchData.union_dues_withholding_id = (this.$refs['assignment.union_dues_withholding_id'] || {}).value || this.assignment.union_dues_withholding_id || '';
                assignmentPatchData.union_member_id = (this.$refs['assignment.union_member_id'] || {}).value || this.assignment.union_member_id || '';
                assignmentPatchData.loanout_status = (this.$refs['assignment.loanout_status'] || {}).value || this.assignment.loanout_status || '0';
                assignmentPatchData.metadata = this.assignment.metadata || {};
                patchData.metadata = this.employee.metadata || {};

                // if address was changed, update everything. this way is better than checking all fields whether each field was changed or not by postgrid.
                if (this.isPermanentUpdated || this.isPermanentAutoCompleted || this.isPermanentOverride) {
                    patchData.main_address1 = this.employee.main_address1;
                    patchData.main_address2 = this.employee.main_address2;
                    patchData.main_city = this.employee.main_city;
                    patchData.main_state_id = this.employee.main_state_id;
                    patchData.main_country_id = this.employee.main_country_id;
                    patchData.main_postal = this.employee.main_postal;
                    this.isPermanentAddressChanged = false;
                    this.isPermanentOverride = false;
                    this.isPermanentAutoCompleted = false;
                }
                if (this.isMailingUpdated || this.isMailingAutoCompleted || this.isMailingOverride) {
                    patchData.mailing_address1 = this.employee.mailing_address1;
                    patchData.mailing_address2 = this.employee.mailing_address2;
                    patchData.mailing_city = this.employee.mailing_city;
                    patchData.mailing_state_id = this.employee.mailing_state_id;
                    patchData.mailing_country_id = this.employee.mailing_country_id;
                    patchData.mailing_postal = this.employee.mailing_postal;
                    this.isMailingAddressChanged = false;
                    this.isMailingOverride = false;
                    this.isMailingAutoCompleted = false;
                }
                if (this.isLoanoutUpdated || this.isLoanoutAutoCompleted || this.isLoanoutOverride) {
                    patchData.loanout_address1 = this.employee.loanout_address1;
                    patchData.loanout_address2 = this.employee.loanout_address2;
                    patchData.loanout_city = this.employee.loanout_city;
                    patchData.loanout_state_id = this.employee.loanout_state_id;
                    patchData.loanout_country_id = this.employee.loanout_country_id;
                    patchData.loanout_postal = this.employee.loanout_postal;
                    this.isLoanoutAddressChanged = false;
                    this.isLoanoutOverride = false;
                    this.isLoanoutAutoCompleted = false;
                }
                if (this.isAgentUpdated || this.isAgentAutoCompleted || this.isAgentOverride) {
                    this.isAgentAddressChanged = false;
                    this.isAgentOverride = false;
                    this.isAgentAutoCompleted = false;
                }
                $("#i9Form .form-change").each(function(ind,el) { i9PatchData[el.name] = el.value });
                $("#ddForm .form-change").each(function(ind,el) { ddPatchData[el.name] = el.value });
                $("#certForm .form-change").each(function(ind,el) { certPatchData[el.name] = el.value });

                if (this.employee.special_type == 1) agentPatchData = this.employee.special_type_properties;
                if (this.employee.special_type == 0 && this.assignment.agent_fee) {
                    this.assignment.agent_fee = '';
                    assignmentPatchData.agent_fee = '';
                }

                i9PatchData.i9_verifier_id = this.assignment.i9_verifier_id;
                i9PatchData.is_rehire = this.assignment.is_rehire;
                patchData.special_type = this.employee.special_type ? this.employee.special_type : 0;
                patchData.papercheck_optin = this.employee.papercheck_optin > 0 || this.employee.papercheck_optin === true ? 1 : 0;

                data = {
                    // employee: this.employee,
                    employeeId: this.employee.id,
                    employee: patchData,
                    employeefull: this.employee,

                    assignmentId: this.assignment.id,
                    assignment: assignmentPatchData,
                    i9Data: i9PatchData,
                    certData: certPatchData,
                    agentData: agentPatchData,
                    ddData: ddPatchData,
                    customForm: customPatchData,
                    customEmployerForm: customEmployerPatchData,
                    canadaForm: canadaPatchData,
                    kitData: kitPatchData,
                    assignmentfull: this.assignment,
                    employer: this.employer,
                    changes: this.changes
                };
                // console.log(data.customForm);
            } else {
                this.createDialog({ "title": "Error", "body": "Please contact Support.", "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            if (options && options.approve === true) {
                // console.log ('Approve');
                data.approve = true;
            } else {
                data.approve = false;
            }

            if (options && options.final === true) {
                // console.log ('Final Approval');
                data.final = true;
            } else {
                data.final = false;
            }
            if (!hideLoader) this.waiting = true;
            try {
                const response = await this.oasisApi[type](this.endpoints.save, data)
                if (response.status == 200){
                    this.changes = [];
                    var url = '/oasis/welcome/dashboard';
                    if (this.type === 'employee') {
                        url = '/oasis/employee/register/' + hash;
                        // Hack for if the use has an existing account
                        if (data.approve === true && response.data === 'Added Start') {
                            url = '/oasis/employee/dashboard/prompt';
                            if (this.isMobile()) url = '/mobiletimecard/index.html#/newTimecard';
                            this.createDialog({ "title": "Success", "body": 'Start Approved.',
                                "buttonYesLabel": "OK", "buttonYesAction": function () { window.location.href = url; },
                                "buttonNo": false
                            });
                        } else if (hideDialog) {
                            // Do nothing
                        } else if (data.approve === true) {
                            if (this.isMobile()) url = '/mobiletimecard/index.html#/newTimecard';
                            window.location.href = url;
                        } else {
                            this.createDialog({ "title": "Success", "body": response.data, "buttonYesLabel": "OK", "buttonNo": false });
                        }

                    // Employer options
                    } else {
                        // Hack for if the use has an existing account
                        if (data.approve === false && response.data === 'Start Updated Successfully') {
                            if (hideDialog) {
                                // Do nothing
                            } else {
                                if (this.isPermanentUpdated || this.isMailingUpdated || this.isLoanoutUpdated || this.isAgentUpdated) {
                                    this.createDialog({ "title": "Address Updated", "body": 'The original address has been updated. Please review.', "buttonYesLabel": "OK", "buttonNo": false });
                                } else {
                                    this.createDialog({ "title": "Success", "body": response.data, "buttonYesLabel": "OK", "buttonNo": false });
                                }
                            }
                        } else if (data.approve === true) {
                            this.createDialog({ "title": "Success", "body": response.data,
                                "buttonYesLabel": "OK",
                                "buttonYesAction": function () { location.reload(); },
                                "buttonNo": false
                            });
                        }
                    }
                // Not sure if we'll ever get a 201 from this page...
                } else if (response.status == 201) {
                    this.changes = [];
                    if (typeof response.data === 'object') {
                        this.employee.employee_id = response.data.employee_id;
                        this.employee.id = response.data.id;
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                } else if (response.status == 400) {
                    if (Array.isArray(response.data)) {
                        let message = '';
                        for (let i = 0; i < response.data.length; i++) {
                            let error = JSON.parse(response.data[i]);
                            $("#job1Form input[name='" + error.field + "']").addClass('form-error2');
                            message += error.message + "\n";
                        }
                        this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                } else {
                    this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                }
                this.waiting = false;
            } catch (error) {
                console.log('error: '); console.log(error); alert (error);
                this.waiting = false;
            };
        },

        // Retrieve link to start PDFs
        printStart(customDocId = null) {
            this.waiting = true;
            const endpoint = (customDocId && !isNaN(customDocId)) ? this.endpoints.printStart + '/' + customDocId : this.endpoints.printStart;

            if (this.assignment.id) {
                this.oasisApi.get(endpoint)
                    .then(response => {
                        // console.log (response);
                        if (response.status == 200 ) {
                            this.createDialog({ "title": "Start Paperwork", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.status == 400) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                        this.waiting = false;
                    })
                    .catch(error => {
                        this.waiting = false;
                        console.log('error: '); console.log(error); 
                    });
            }
            else {
                this.createDialog({ "title": "Warning", "body": "Start is not complete.  Please save first.", "buttonNo": false, "buttonYesLabel": "OK" });
            }
        },

        // Retrieve link to start PDFs on EE completeNew form
        printStartNew(docId) {
            this.waiting = true;
            if (this.assignment.id) {
                this.oasisApi.get('/printStart/' + this.assignment.id + '/' + docId)
                    .then(response => {
                        if (response.status == 200 ) {
                            this.createDialog({ "title": "Start Paperwork", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else if (response.status == 400) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                        this.waiting = false;
                    })
                    .catch(error => {
                        this.waiting = false;
                        console.log('error: '); console.log(error); 
                    });
            }
            else {
                this.createDialog({ "title": "Warning", "body": "Start is not complete.  Please save first.", "buttonNo": false, "buttonYesLabel": "OK" });
                this.waiting = false;
            }
        },

        // Same as print start except marks that the employee viewed the start.
        async getStartLink () {
            this.waiting = true;
            const endpoint = this.endpoints.printStart;
            try {
                await this.updateStart({ hideDialog: true });
                const response = await this.oasisApi.get(endpoint)
                // console.log (response);
                if (response.status == 200 ) {
                    this.employeeStartLink = response.data;
                    // this.approveModal = true;
                } else if (response.status == 400) {
                    this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                } else {
                    this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                }
                this.waiting = false;
            } catch (error) {
                this.waiting = false;
                console.log('error: '); console.log(error); 
            }
        },
        
        employeeViewStart() {
            this.employeeApprovalStep = 1;
        },

        acceptedSignature (event) {
            if (event === false) {
                this.isSigned = false;
            } else {
                this.isSigned = true;
                this.employeeApprovalStep = 3;
            }
        },

        // Dialog Box to cancel start
        cancelStart() {
            this.createDialog({
                "title": "Confirm Void", "body": 'Are you sure you want to void this start paperwork?',
                "buttonYesLabel": "Yes, Void", "buttonYesAction": function () { app.voidStart(); },
                "buttonNoLabel": "No Thanks"
            });
        },

        editStart() {
            let url = '/oasis/starts/edit/' + this.assignment.hash;
            window.location.href = url;
        },

        kickbackStart () {
            if (! this.assignment.hash) {
                this.createDialog({ "title": "Error", "body": 'This start cannot be unapproved.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            let startHash = this.assignment.hash; // Needed for scope
            this.createDialog({ "title": "Please Confirm",
                "body": 'Are you sure you want to return this start to the employee?',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function() { app.changeApi('unapprove', startHash);}
            });
            return true;
        },

        // Cancel a start
        voidStart() {
            let endpoint = '';
            if (this.type === 'employee') {
                endpoint = '/employee/decline/';
            } else {
                endpoint = '/assignments/';
            }

            this.waiting = true;
            this.oasisApi.delete(endpoint + this.assignment.hash, null)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200 ) {
                        this.createDialog({ "title": "Start Paperwork", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else if (response.status == 400) {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    this.waiting = false;
                    console.log('error: '); console.log(error); 
                })
            ;
        },

        changeApi(type, selected) {
            if (!type || ! selected) return false;

            let apiEndpoint;
            if (type === 'void') {
                apiEndpoint = '/bulkchange/start/void';
            } else if (type === 'unapprove') {
                apiEndpoint = '/bulkchange/start/unapprove';
            } else {
                return false;
            }

            let data = {
                starts: [ selected ],
                message: this.employerMessage,
            };

            this.waiting = true;

            this.oasisApi.patch(apiEndpoint, data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200){
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK", "buttonYesAction": function () { location.reload()} });
                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert (error);
                    this.waiting = false;
                })
            ;

        },

        getAssets(assignment) {
            let data = {
                hash: assignment.hash,
                assignmentId: assignment.id,
                employeeId: assignment.employee_id
            };

            this.oasisApi.post('/assets/get/starts', data)
                .then(response => {
                    if (response.status == 200 ) {
                        this.assets = response.data;
                    }
                })
                .catch(error => {
                    console.log('error: '); console.log(error); 
                })
            ;
        },

        isAcknowledged () {
            if (this.assignment.dd_status >= 1 && !this.dd_acknowledge) return false;
            if (this.assignment.loanout_status >= 1 && !this.loanout_acknowledge) return false;
            for (const i in this.acknowledge) {
                // console.log(this.acknowledge[i])
                if (this.acknowledge[i] !== true) return false;
            }
            return true;
        },

        // Load Direct Deposit
        loadDd () {
            let uploadedAssetId = undefined;
            if (! this.employee.previousDD) {
                return false;
            }

            for (const label in this.employee.previousDD) {
                const value = this.employee.previousDD[label]
                if (label === 'asset_id' && value && value > 0) {
                    uploadedAssetId = value;
                } else {
                    this.assignment[label] = value;
                }
            }
            if (uploadedAssetId) {
                this.getDdAsset(uploadedAssetId);
                this.uploadedDdAsset = true;
            }

            setTimeout(() => {
                this.nextEmployeeStep();
                this.$refs['assignment.dd_bank_confirm_1'].classList.add('form-missing')
            }, 100);
        },

        getDdAsset(id=null) {
            if (!id) return;

            this.oasisApi.get('/assets/get/' + id)
                .then(response => {
                    if (response.status == 200 ) {
                        this.ddAssets = response.data;
                    }
                })
                .catch(error => {
                    console.log('error: '); console.log(error); 
                })
            ;
        },

        /* For new employee wizard
         * Steps are currently:
         *   Start: beginning which reviews basic name to verify employee
         *   JobInfo: Readonly fields to confirm job details/rates
         *   Union: If union, ask for details
         *   EmployeeDetails: Show name/email/loanout choice?  EEOC here?
         *   Address: real/mailing address
         *   MailingAddress: real/mailing address
         *   Demographics: EEOC/CCPR/CDPR collection
         *   Loanout: Optional screen if loanout
         *   Agent: Optional screen if there is an agent
         *   TaxInfo: If not a loanout, ask for details
         *   Canada: if we have forms show here
         *   CanadaRes: if we have forms show here
         *   (not implemented) CountryForms: if we have forms show here
         *   StateForms: if we have forms show here
         *   CustomForms: if we have forms show here
         *   EmploymentAuthorization: I9 for non-loanouts
         *   BoxInventory: Optional if kit rental is filled out on start
         *   DirectDeposit: allow user to select dd
         *   DirectDeposit1: 1st bank
         *   DirectDeposit2: 2nd bank
         *   DirectDeposit3: Upload
         *   Approval0: review forms
         *   Approval1: acknowledgements
         *   Approval2: sign
         *   EmployeeCertification
         *   Approval3: Done
         * 
         *   TODO:  
         *     PDF Viewer
         *     validation per step
         *     save
         *     iPhone scroll
         *     i9 and dd verification
         *     get new token on save
         *     certification
         *     computed for section completion
         *     breadcrumbs?
         */
        async setCurrentStep(name) {
            if (name === 'Approval1' || name === 'Approval2' || name === 'Approval3') {
                let checks = await this.checkAllSteps();
                if (!checks) {
                    return false;
                }
            }

            if (name === 'Approval0') {
                this.employeeStartLink = undefined;
            } else {
                if (this.changes.length > 0) this.updateStart({ hideDialog: true, hideLoader: true });
            }

            this.currentStep = name;
            this.setFocus(name);
        },

        async prevEmployeeStep(event) {
            this.nextEmployeeStep(event, true);
        },

        async nextEmployeeStep(event = null, previous = false, forceApprove = false) {
            // Check the data in this section
            const currPanel = this.$refs['panel' + this.currentStep];
            if (!currPanel) console.log('No ' + this.currentStep);

            // Force viewer close
            this.viewerModal = false;

            // Figure out next step
            let next;
            let prev;
            switch (this.currentStep) {
                case 'Start':
                    next = 'JobInfo';
                    prev = 'Start';
                    break;

                case 'JobInfo':
                    if (this.showUnion) next = 'Union';
                    else next = 'EmployeeDetails';
                    prev = 'Start';
                    break;

                case 'Union':
                    next = 'EmployeeDetails';
                    prev = 'JobInfo';

                    break;

                case 'EmployeeDetails':
                    next = 'Address';
                    if (this.showUnion) prev = 'Union';
                    else prev = 'JobInfo';
                    break;

                case 'Address':
                    next = 'MailingAddress';
                    prev = 'EmployeeDetails';
                    break;

                case 'MailingAddress':
                    if (this.showForeign && this.showLoanout) next = 'Loanout';
                    else if (this.showForeign && this.showLoanout) next = 'Loanout';
                    else if (this.showForeign && this.showAgent) next = 'Agent';
                    else if (this.showForeign && this.showW4Box) next = 'TaxInfo';
                    else if (this.showCanada) next = 'Canada';
                    // else if (this.showForeign) next = 'CountryForms';
                    else next = 'Demographics';
                    prev = 'Address';
                    break;

                case 'Demographics':
                    if (this.showLoanout) next = 'Loanout';
                    else if (this.showAgent) next = 'Agent';
                    else if (this.showW4Box) next = 'TaxInfo';
                    else if (this.showCanada) next = 'Canada';
                    // else if (this.isForeign) next = 'CountryForms';
                    else next = 'StateForms';

                    prev = 'MailingAddress';
                    break;

                case 'Loanout':
                    if (this.verifyCaEddNumber(this.employee.loanout_ca_edd) === false) {
                        return false;
                    }
                    if (this.showAgent) next = 'Agent';
                    else if (this.showW4Box) next = 'TaxInfo';
                    else if (this.showCanada) next = 'Canada';
                    else next = 'StateForms';

                    prev = (this.showForeign) ? 'MailingAddress' : 'Demographics';

                    break;

                case 'Agent':
                    if (this.showW4Box) next = 'TaxInfo';
                    else if (this.showCanada) next = 'Canada';
                    else next = 'StateForms';

                    if (this.showLoanout) prev = 'Loanout';
                    else if (this.showForeign) prev = 'MailingAddress';
                    else prev = 'Demographics';
                    break;

                case 'TaxInfo':
                    if (this.showCanada) next = 'Canada';
                    else next = 'StateForms';

                    if (this.showAgent) prev = 'Agent';
                    else if (this.showLoanout) prev = 'Loanout';
                    else if (this.showForeign) prev = 'MailingAddress';
                    else prev = 'Demographics';

                    break;

                case 'Canada':
                    next = 'CanadaRes';

                    if (this.showW4Box) prev = 'TaxInfo';
                    else if (this.showAgent) prev = 'Agent';
                    else if (this.showLoanout) prev = 'Loanout';
                    else if (this.showForeign) prev = 'MailingAddress';
                    else prev = 'Demographics';

                    break;

                case 'CanadaRes':
                    next = 'StateForms';
                    prev = 'Canada';
                    break;

                case 'CountryForms':
                    next = 'StateForms';

                    if (this.showCanada) prev = 'CanadaRes';
                    else if (this.showW4Box) prev = 'TaxInfo';
                    else if (this.showAgent) prev = 'Agent';
                    else if (this.showLoanout) prev = 'Loanout';
                    else if (this.showForeign) prev = 'MailingAddress';
                    else prev = 'Demographics';

                    break;

                case 'StateForms':
                    if (this.showCustomForms) next = 'CustomForms';
                    else if (this.showI9) next = 'EmploymentAuthorization';
                    else if (this.showBoxInventory) next = 'BoxInventory';
                    else if (this.showEmployeeCertification) next = 'EmployeeCertification';
                    else if (this.showDirectDeposit) next = 'DirectDeposit';
                    else next = 'Approval0'

                    if (this.showCanada) prev = 'CanadaRes';
                    else if (this.showW4Box) prev = 'TaxInfo';
                    else if (this.showAgent) prev = 'Agent';
                    else if (this.showLoanout) prev = 'Loanout';
                    else if (this.showForeign) prev = 'MailingAddress';
                    else prev = 'Demographics';

                    break;

                case 'CustomForms':
                    if (this.showI9) next = 'EmploymentAuthorization';
                    else if (this.showBoxInventory) next = 'BoxInventory';
                    else if (this.showEmployeeCertification) next = 'EmployeeCertification';
                    else if (this.showDirectDeposit) next = 'DirectDeposit';
                    else next = 'EmploymentAuthorization';

                    prev = 'StateForms';
                    break;

                case 'EmploymentAuthorization':
                    if (this.showBoxInventory) next = 'BoxInventory';
                    else if (this.showEmployeeCertification) next = 'EmployeeCertification';
                    else if (this.showDirectDeposit) next = 'DirectDeposit';
                    else next = 'Approval0';

                    prev = this.showCustomForms ? 'CustomForms' : 'StateForms';
                    break;

                case 'BoxInventory':
                    if (this.showEmployeeCertification) next = 'EmployeeCertification';
                    else if (this.showDirectDeposit) next = 'DirectDeposit';
                    else next = 'Approval0';

                    prev = 'EmploymentAuthorization';
                    break;

                case 'EmployeeCertification':
                    if (this.showDirectDeposit) next = 'DirectDeposit';
                    else next = 'Approval0';

                    prev = 'DirectDeposit';
                    if (this.showBoxInventory) prev = 'BoxInventory';
                    else if (this.showI9) prev = 'EmploymentAuthorization';
                    else if (this.showCustomForms) prev = 'CustomForms';
                    else prev = 'StateForms';

                    break;

                case 'DirectDeposit':
                    next = this.showDirectDeposit1 ? 'DirectDeposit1' : 'Approval0';

                    if (this.showEmployeeCertification) prev = 'EmployeeCertification';
                    else if (this.showBoxInventory) prev = 'BoxInventory';
                    else if (this.showI9) prev = 'EmploymentAuthorization';
                    else if (this.showCustomForms) prev = 'CustomForms';
                    else prev = 'StateForms';

                    break;

                case 'DirectDeposit1':
                    if (this.showDirectDeposit && parseInt(this.assignment.dd_status) === 1 && this.uploadedDdAsset) next = 'Approval0';
                    else if (this.showDirectDeposit && parseInt(this.assignment.dd_status) === 1) next = 'DirectDeposit3';
                    else if (this.showDirectDeposit && parseInt(this.assignment.dd_status) === 2) next = 'DirectDeposit2';
                    else next = 'Approval0';

                    prev = 'DirectDeposit';
                    break;

                case 'DirectDeposit2':
                    next = this.uploadedDdAsset ? 'Approval0' : 'DirectDeposit3';
                    prev = 'DirectDeposit1';
                    break;

                case 'DirectDeposit3':
                    next = 'Approval0';
                    prev = this.showDirectDeposit ? 'DirectDeposit' : (this.showBoxInventory ? 'BoxInventory' : 'EmploymentAuthorization')
                    break;

                case 'Approval0':
                    next = 'Approval1';
                    prev = this.showDirectDeposit1 ? 'DirectDeposit3' : 'DirectDeposit';
                    break;

                case 'Approval1':
                    next = 'Approval2';
                    prev = 'Approval0';
                    break;

                case 'Approval2':
                    next = 'Approval3';
                    prev = 'Approval1';

                    if (previous) {
                        // Do not Approve if the user is clicking back
                    } else if (forceApprove !== true) {
                        this.approveStart({ approve: true, hideDialog: true });
                    }
                    break;

                case 'Approval3':
                    next = 'Approval3';
                    prev = 'Approval2';
                    break;

                default:
                    next = 'Approval1';
                    prev = 'Start';
            }

            if (previous && !prev) {
                return;
            }
            else if (previous) {
                // console.log($('#panel'+this.currentStep));
                // console.log($('#panel'+prev));
                // If employee get validation error, can't move previous
                const validate = await this.checkStep();
                if (validate.errors === true) {
                    const message = validate.message || 'Please check highlighted fields before continuing.<br />';
                    this.createDialog({ "title": "Warning", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    this.updateMetaData(this.currentStep, 'fail');
                    return false;
                } else {
                    if (this.isPermanentUpdated || this.isMailingUpdated || this.isLoanoutUpdated || this.isAgentUpdated) {
                        this.createDialog({ "title": 'Address Updated', "body": 'The original address has been updated. Please review.', "buttonNo": false, "buttonYesLabel": "OK"  });
                        return false;
                    }

                    this.updateMetaData(this.currentStep, null, prev); // Don't update if back.
                    return true;
                }
            }
            else if (!next) {
                // console.log('No next step');
                return;
            }

            // Assume we are going next
            // Quick validate of required fields
            // If employee get validation error, can't move next
            const validate = await this.checkStep();
            if (validate.errors === true) {
                const message = validate.message || 'Please check highlighted fields before continuing.<br />';
                this.createDialog({ "title": "Warning", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                this.updateMetaData(this.currentStep, 'fail');
                return false;
            } else {
                if (this.isPermanentUpdated || this.isMailingUpdated || this.isLoanoutUpdated || this.isAgentUpdated) {
                    this.createDialog({ "title": 'Address Updated', "body": 'The original address has been updated. Please review.', "buttonNo": false, "buttonYesLabel": "OK"  });
                    return false;
                }

                // Force approve to move to the last step
                if (forceApprove) {
                    this.approveStart({ approve: true, hideDialog: true });
                } else {
                    this.updateMetaData(this.currentStep, 'success', next);
                }

                return true;
            }
        },

        setFocus(step) {
            const currStep = step || this.currentStep
            const heading = this.$refs['heading' + currStep];
            const panel = this.$refs['panel' + currStep];
            if (!heading || typeof heading.scrollIntoView !== 'function') {
                // console.log('No next step for ' + currStep);
            } else {
                // console.log('setting Focus ' + currStep, heading);
                setTimeout(() => {
                    $('#panel' + currStep).collapse('show');
                    heading.scrollIntoView(true);
                }, 300);
            }
        },

        // Update the metadata and save
        async updateMetaData(stepName, type, nextStep) {
            if (type === 'success') {
                if (!this.finished.includes(stepName)) this.finished.push(stepName);
                if (this.failed.includes(stepName)) this.failed.splice(this.failed.indexOf(stepName), 1)
            } else if (type === 'fail') {
                if (!this.failed.includes(stepName)) this.failed.push(stepName);
                if (this.finished.includes(stepName)) this.finished.splice(this.finished.indexOf(stepName), 1)
            } else {
                // Don't mark as success or fail...
                // console.log('No update metadata');
            }

            // console.log(this.finished, this.failed, this.currentStep, nextStep);
            if (nextStep) {
                $('#panel' + stepName).collapse('hide');
                this.setCurrentStep(nextStep);
            }
            this.assignment.metadata.finished = this.finished;
            this.assignment.metadata.failed = this.failed;
            this.assignment.metadata.currentStep = this.currentStep
            this.updateStart({ hideDialog: true, hideLoader: false });
        },

        // Probably good forMixins!
        // Dropzone stuff
        dzSuccess() {
            this.getAssets(this.assignment);
        },

        // Specific to Direct Deposit
        dzDdSuccess() {
            this.uploadedDdAsset = true;
            this.dzSuccess();
        },

        dzCertificationSuccess(value) {
            this.dzSuccess(value);
        },
        dzSave() {
            this.documentModal = false;
            this.loanoutDocModal = false;
            this.agentDocModal = false;
            this.i9DocModal = false;
            this.residencyDocModal = false;
            this.ddDocModal = false;
            this.certDocModal = false;
        },

        dzRemove(hash) {
            this.oasisApi.get('/assets/delete/' + hash)
                .then(response => {
                    if (response.status == 200 ) {
                        this.getAssets(this.assignment);
                    }
                })
                .catch(error => {
                    console.log('error: '); console.log(error); 
                })
            ;
        },

        dzApprove(value) {
            this.paperFormModal = false;
            location.reload();
        },

        acceptAllowances() {
            this.allowanceModal = false;
            if (this.w4.exempt === true) this.employee.exemptions = -1;
            else this.employee.exemptions = this.totalAllowances;
            if (this.w4.exempt_state === true) this.employee.exemptions_state = -1;

            $("input[name='exemptions']").removeClass("form-missing");
            $("input[name='exemptions_state']").removeClass("form-missing");
            $("input[name='exemptions']").addClass("form-change");
            $("input[name='exemptions_state']").addClass("form-change");
        },

        acceptW4() {
            // Check W4
            let errors = '';
            this.$refs['employee.w4_children'].classList.remove('error');
            this.$refs['employee.w4_other_dependents'].classList.remove('error');
            this.$refs['employee.w4_dependent_adj'].classList.remove('error');

            let standardDeduction = 0;
            // Married/Widow
            if (this.employee.marital_status_id == 2 || this.employee.marital_status_id == 5) {
                standardDeduction = 30000;
            // Single
            } else if (this.employee.marital_status_id == 1 || this.employee.marital_status_id == 3) {
                standardDeduction = 15000;
            // Head of Household
            } else if (this.employee.marital_status_id == 4) {
                standardDeduction = 22500;
            } else {
                standardDeduction = 15000;
            }

            this.employee.w4_job_count = parseInt(this.w4.jobs) + parseInt(this.w4.jobsSpouse);
            this.employee.w4_dependent_adj = (parseInt(this.employee.w4_children) * 2200) + (parseInt(this.employee.w4_other_dependents) * 500);
            this.employee.w4_deductions = parseFloat(this.w4.deduction_amount) > standardDeduction ? parseFloat(this.w4.deduction_amount) - standardDeduction : 0 
            if ((this.employee.w4_children || this.employee.w4_other_dependents) && (parseFloat(this.employee.w4_dependent_adj || 0) !== (parseFloat(this.employee.w4_children || 0) * 2200 + parseFloat(this.employee.w4_other_dependents || 0) * 500))) {
                this.$refs['employee.w4_dependent_adj'].classList.add('error');
                errors += 'Please check your W-4 dependent adjustment. It should be equal to your children + other dependent credit ($' + (parseFloat(this.employee.w4_children || 0) * 2200 + parseFloat(this.employee.w4_other_dependents || 0) * 500) + ').<br />';
            } else if (this.employee.w4_dependent_adj && parseFloat(this.employee.w4_dependent_adj || 0) > 0 && this.employee.w4_dependent_adj % 500 !== 0) {
                this.$refs['employee.w4_dependent_adj'].classList.add('error');
                errors += 'Please check your W-4 dependent adjustment. It should be in multiples of $500. <br />';
            }
            if (errors) {
                this.createDialog({ "title": "Error", "body": errors, "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            this.w4Modal = false;
            this.$refs['employee.w4_exempt'].classList.add('form-change');
            this.$refs['employee.w4_children'].classList.add('form-change');
            this.$refs['employee.w4_other_dependents'].classList.add('form-change');
            this.$refs['employee.w4_job_count'].classList.add('form-change');
            this.$refs['employee.w4_dependent_adj'].classList.add('form-change');
            this.$refs['employee.w4_other_income'].classList.add('form-change');
            this.$refs['employee.w4_deductions'].classList.add('form-change');
            this.$refs['employee.w4_extra_wh'].classList.add('form-change');
        },

        // Add like input to get to get acceptable W-4 values
        updateW4() {
            this.employee.w4_dependent_adj = (parseInt(this.employee.w4_children) * 2200) + (parseInt(this.employee.w4_other_dependents) * 500);
        },

        acceptTd1() {
            this.td1Modal = false;
        },

        // Upon initial load, check the location states and add state/resident forms
        addStateForms() {
            // Initial run
            // if (this.stateForms && this.employee.state_forms.length === 0) {
            const startState = parseInt((this.mainLocation || {}).state_id);
            this.stateForms.forEach((form) => {
                // console.log(parseInt(form.document_type_id), form.properties.loanout_doc, this.isLoanout);
                const formIndex = this.employee.state_forms.findIndex((ind) => parseInt(ind) === parseInt(form.id));
                const formDefaultState = parseInt(((form.properties || {}).locations || {}).defaultState || 0) || null;

                // Skip if loanout
                if (!form.properties.loanout_doc && this.isLoanout) {
                    // console.log('Skipping for loanout ' + form.id + ' ' + formIndex);
                    if (formIndex > -1) this.employee.state_forms.splice(formIndex, 1);
                // Skip if work state is not a match
                } else if (startState !== formDefaultState) {
                    // console.log('Skipping for not matching ' + form.id + ' ' + formIndex);
                    if (formIndex > -1) this.employee.state_forms.splice(formIndex, 1);
                } else {
                    if (this.employee.state_forms.indexOf(form.id) < 0) this.employee.state_forms.push(form.id);
                }
            })

            this.incentiveForms.forEach((form) => {
                // Residency/incentive forms
                // console.log('Residency: ' + form.id);
                const formDefaultState = parseInt(((form.properties || {}).locations || {}).defaultState || 0) || null;
                const index = this.employee.state_forms.indexOf(form.id);
                if (this.employee.metadata.residentState[formDefaultState] && index < 0) this.employee.state_forms.push(form.id);
                else if (!this.employee.metadata.residentState[formDefaultState] && index > -1) this.employee.state_forms.splice(index);
            })

            // TODO Check resident and mailing addresses
            if (this.stateForms && (this.employee.mailing_state_id || this.employee.main_state_id)) {
                this.stateForms.forEach((form) => {
                    // console.log(form);
                })
            }
            // console.log(this.employee.state_forms);
            this.updateStateForms();
        },

        // Function to modify custom forms.  Basically, add fields only if new custom forms are selected.  Don't remove as they just won't print...  TODO?
        updateStateForms() {
            // No state forms, no need to update.  // for now remove fields too.  see later TODO on inactive/active
            if (! this.employee.state_form_fields) {
                this.employee.state_form_fields = {};
            }

            // Now go through each form's fields and add to the employee
            this.selectedStateForms.forEach(form => {
                (form.fields || []).forEach(formField => {
                    // console.log(formField.id, formField.status, formField.field, formField.name, formField.type);
                    if (parseInt(formField.status) > 0 && ! this.employee.state_form_fields.hasOwnProperty(formField.field)) {
                        this.employee.state_form_fields[formField.field] = { id: formField.id, name: formField.field, label: formField.name, type:formField.type, required: formField.required, length: formField.length, sortOrder: formField.sort_order, role: formField.role, documentId: formField.custom_document_id }
                        if (formField.type === 'boolean') this.employee.state_form_fields[formField.field].value = false;
                        if (formField.default_value && !this.employee.state_form_fields[formField.field].value) {
                            this.employee.state_form_fields[formField.field].value = formField.default_value;
                        }
                    }
                });
            });
        },

        getCertifications(employee) {
            if (!employee) employee = this.employee;
            if (!employee.hash) return null;

            this.oasisApi.get(this.endpoints.certifications + employee.hash)
                .then(response => {
                    // console.log(response)
                    if (response.status == 200) {
                        if (Array.isArray(this.certifications)) {
                            this.certifications = response.data.results;
                            const matches = this.certifications.filter((cert) => parseInt(cert.certification_type_id) === parseInt(this.assignment.certification_type_id)) || [];
                            if (matches.length) {
                                this.certificationStatus = matches[0];
                                this.localFormatCertificationDate = this.parseLuxon(this.certificationStatus.completion_date).toFormat(this.format);
                                this.isCertified = true;
                            } else {
                                this.isCertified = false;
                            }
                        } else {
                            this.isCertified = false;
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.isCertified = false;
                    }
                })
                .catch(error => {
                    console.log('error: '); console.log(error); 
                    this.createDialog({ "title": "Error", "body": error, "buttonNo": false, "buttonYesLabel": "OK" });
                })
            ;
        },

        async addCertification(hideDialog = false) {
            if (!this.localFormatCertificationDate || this.errors.certification_completion_date === true) {
                this.$refs['certificationStatus.completion_date'].classList.add('form-missing');
                if (!hideDialog) this.createDialog({ "title": "Warning", "body": 'Please check highlighted fields before submitting.', "buttonYesLabel": "OK", "buttonNo": false });
                return null;
            }
            if (this.certDocs.length == 0 && !this.isCertified) {
                if (!hideDialog) this.createDialog({ "title": "Warning", "body": 'Please upload a completion certificate.', "buttonYesLabel": "OK", "buttonNo": false });
                return null;
            }

            if (!this.employee) return null
            if (!this.employee.hash) return null;
            
            let data = {
                employee_id: this.employee.id,
                certification_type_id: this.assignment.certification_type_id,
                certification_number: this.certificationStatus.certification_number || null,
                completion_date: DateTime.fromFormat(this.localFormatCertificationDate,this.format).toFormat('yyyy-MM-dd'),
                trainer: this.certificationStatus.trainer || null,
            };

            let method = 'post';
            if (this.certificationStatus.id) {
                data.id = this.certificationStatus.id;
                method = 'patch';
            }

            let response = await this.oasisApi[method](this.endpoints.certifications + this.employee.hash, data);
            if ((response.status == 200 || response.status == 201) && response.data.results && response.data.results.length) {
                this.certificationStatus.id = response.data.results[0].id
                this.isCertified = true;
                if (!hideDialog) this.createDialog({ "title": "Success", "body": 'Certification uploaded.', "buttonYesLabel": "OK", "buttonNo": false });
                if (this.isWorkPlaceChanged) this.isWorkPlaceChanged = false;
                this.getAssets(this.assignment);
                return true;
            } else {
                if (!hideDialog) this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
            }
            return null;
        },

        onClickCertified() {
            // Save first
            this.updateStart({ hideDialog: true });

            // Open a new tab to the state website
            window.open('/oasis/employee/externalCertification/' + this.assignment.certification_type_id + '/' + hash, '_certification');
        },

        loadStartList(hashes = null) {
            if (!hashes) {
                const local = JSON.parse(localStorage.getItem('readyToApproveStarts'));
                if (! local) return false;
                else hashes = local;
            }

            this.startList = hashes;
        },

        gotoNextStart() {
            if (! this.nextStart) return false;
            window.location.href = '/oasis/starts/approve/' + this.nextStart;
        },

        gotoPrevStart() {
            if (! this.prevStart) return false;
            window.location.href = '/oasis/starts/approve/' + this.prevStart;
        },

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        isJson(string, log=false) {
            if (log) console.log(string)

            if (typeof string === 'object') {
                if (log) console.log('JSON!')
                return true;
            }

            try {
                JSON.parse(string);
            } catch (e) {
                if (log) console.log('Not JSON. Could not Parse')
                return false;
            }
            
            if (typeof JSON.parse(string) === 'object') {
                if (log) console.log('Parsed JSON!')
                return true;
            } else {
                if (log) console.log('Not JSON. Not Object')
                return false;
            }
        },

        highlightChange( {target} ) {
            target.classList.remove('form-missing');
            target.classList.add('form-change');
            this.changes.push({name: target.name, value: target.value});
        },

        highlightChangeI9( {target} ) {
            this.highlightChange( {target} );
            this.assignment.is_rehire = null;
        },

        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        cancelCurrent() {
            var url = '/oasis/welcome/dashboard';
            if (this.type === 'employee') {
                let isProd = window.location.href.match(/prohire.revolutiones.com/);
                if (isProd) url = 'https://www.revolutiones.com/';
                else url = '/';
            }
            if (this.changes.length > 0) {
                this.createDialog({ "title": "Are You Sure?", "body": "You may lose your work.  Proceed?",
                    "buttonYesAction": function () { window.location.href = url; },
                });
            } else {
                window.location.href = url;
            }
        },

        drawSignatureLine() {
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);
            this.canvas.width = this.canvas.offsetWidth * ratio;
            this.canvas.height = this.canvas.offsetHeight * ratio;
            this.canvas.getContext("2d").scale(ratio, ratio);
            this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        },

        verifySSN({ target }) {
            // Allow an override
            if (this.assignment.loanout_status > 0 && ( target.value == 0 || target.value.toLowerCase() === 'na' )) {
                this.employee[target.name] = 'NA';
                this.errors[target.name] = false;
                this.changed[target.name] = true;
                return true;
            }

            if (parseInt(this.assignment.country_id) === 1) {
                // US
                let digits = target.value.replace (/[^0-9]/g,'');
                if (digits.length === 9) {
                    // correct
                    this.employee[target.name] = digits.substr(0,3) + '-' + digits.substr(3,2) + '-' + digits.substr(5,4);
                    this.errors[target.name] = false;
                    this.changed[target.name] = true;
                    return true;
                } else {
                    this.errors[target.name] = true;
                    return false;
                }
            } else if (this.isCanada) {
                // Canada
                let digits = target.value.replace (/[^0-9]/g,'');
                // basic validation. 9 ditis
                if (digits.length === 9) {
                    // Luhn algorithm will be applied except admin user
                    if (!this.adminAccess) {
                        let total = 0;
                        for (let i=1; i<digits.length+1; i++) {
                            if (i%2 === 0) {
                                let temp = parseInt(digits[i-1]) * 2;
                                total += parseInt((temp/10)) + parseInt((temp%10));
                            } else {
                                total += parseInt(digits[i-1]);
                            }
                        }
                        if ( (total % 10) != 0) {
                            this.createDialog({ "title": "Warning", "body": 'The Social Insurance Number entered is not valid. Please review and update.', "buttonNo": false, "buttonYesLabel": "OK" });
                            this.errors[target.name] = true;
                            return false;
                        }
                    }
                    this.errors[target.name] = false;
                    this.changed[target.name] = true;
                    return true;
                } else {
                    this.createDialog({ "title": "Warning", "body": 'The Social Insurance Number entered is not valid. Please review and update.', "buttonNo": false, "buttonYesLabel": "OK" });
                    this.errors[target.name] = true;
                    return false;
                }
            } else {
                // not US and Canada
                this.employee[target.name] = target.value;
                this.errors[target.name] = false;
                this.changed[target.name] = true;
                return true;
            }
        },

        verifyBirthDate({ target }) {
            if (! this.verifyDate(target,'birthdate')) {
                $("input[name='birth_date']").addClass("form-error");
                return false;
            } else {
                $("input[name='birth_date']").removeClass("form-error");
                $("input[name='birth_date']").addClass("form-change");
                return true;
            }
        },

        // Can only be within last year
        verifyCertDate({ target }) {
            return this.verifyDate(target,'certification');
        },

        // Verify EDD number.  Should be 8 digits or "None"
        // Allow passing the direct value or a target object
        verifyCaEddNumber(data) {
            if (!this.isCaEddRequired) return true;

            // Figure out where the edd number is
            let number;
            if (!data) {
                number = null;
            } else if (data.target && data.target.value) {
                number = data.target.value;
            } else if (data.target) {
                number = data.target;
            } else if (typeof data === 'string' || typeof data === 'number') {
                number = data;
                if (number === 'None') return true;
            }

            // If not a string or target, then not valid
            if (typeof number === 'string' || typeof number === 'number') {
                const cleanNumber = number.replace(/[^0-9]/g, '');
                if (cleanNumber.length !== 8) {
                    // console.log('EDD Number not 8: ' + cleanNumber);
                    this.$nextTick(() => {
                        this.$refs['employee.loanout_ca_edd'].classList.remove('form-change');
                        this.$refs['employee.loanout_ca_edd'].classList.add('form-missing');
                    })
                    return false;
                }
                else {
                    // console.log('EDD Number 8: ' + cleanNumber);
                    this.$nextTick(() => {
                        this.$refs['employee.loanout_ca_edd'].classList.remove('form-missing');
                    })
                    return true;
                }
            } else {
                // console.log('EDD Number not string/number: ' + number);
                this.$nextTick(() => {
                    this.$refs['employee.loanout_ca_edd'].classList.remove('form-change');
                    this.$refs['employee.loanout_ca_edd'].classList.add('form-missing');
                })
                return false;
            }
        },

        setNoExpDate(field) {
            this.assignment[field] = 'NA';
            this.changedValue(field);
        },

        // to check valid date or not. ex) 2/30/2030 -> invalid.
        isValidDate(month, day, year) {
            month = month - 1;
            var d = new Date(year, month, day);
            if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
              return true;
            }
            return false;
        },

        verifyDate(target, type) {
            if (! target || typeof target.value === 'undefined' ) {
                return true;
            }
            let splitDate;

            // format that is from dateField is YYYY-MM-DD so need to match format MM/DD/YYYY and type change from dataField to expiration
            // It is simple way to work this existing function.
            if (type === 'expiration') {
                let digits = target.value.replace (/[^0-9]/g,'');
                let year = digits.substr(0,4);
                let month = digits.substr(4,2);
                let day = digits.substr(6,2);
                digits = month + '/' + day + '/' + year;
                splitDate = digits.split('/');
            } else {
                let temp = target.value.replace(/[ \.\,\/-]/g, '/').split('/');
                if (temp.length != 3 || !temp[0] || !temp[1] || !temp[2]) {
                    this.errors[target.name] = true;
                    return false;
                }
                // make MM/dd/yyyy format to make compatible with existing logic.
                if (this.format === 'yyyy/MM/dd') {
                    temp = temp[1] + '/' + temp[2] + '/' + temp[0];
                } else if (this.format === 'dd/MM/yyyy') {
                    temp = temp[1] + '/' + temp[0] + '/' + temp[2];
                } else {
                    temp = temp.join('/');
                }
                splitDate = temp.split('/');
            }
            let finalDate = undefined;
            // Allow an override
            if (this.assignment.loanout_status > 0 && ( target.value == 0 || target.value.toLowerCase() === 'na' )) {
                this.employee[target.name] = 'NA';
                this.errors[target.name] = false;
                this.changed[target.name] = true;
                return true;
            } else if (splitDate[2].length == 2) {
                let year = parseInt (splitDate[2]);
                let fullYear = undefined;
                if (year > 0 && year <= 19) fullYear = '20' + year;
                else if (year >= 20 && type === 'birthdate') fullYear = '19' + year;
                else if (year >= 20 && type === 'expiration') fullYear = '20' + year;
                else fullYear = '20' + year;
                splitDate[2] = fullYear;
            }

            if (!this.isValidDate(splitDate[0], splitDate[1], splitDate[2])) {
                this.errors[target.name] = true;
                return false;
            }
            finalDate = new Date(splitDate.join('/'));

            let oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

            // Now check age
            if (type === 'birthdate' && finalDate >= new Date()) {
                // too young!
                // console.log ('Too Young');
                this.changed[target.name] = false;
                this.errors[target.name] = true;
                return false;
            } else if (type === 'birthdate' && new Date() - finalDate > 3000000000000) {
                // too old!
                // console.log ('Too Old');
                this.changed[target.name] = false;
                this.errors[target.name] = true;
                return false;
            } else if (type === 'birthdate') {
                // date is valid and good, I guess
                this.localFormatBirthDate = DateTime.fromJSDate(finalDate).toFormat(this.format);
                this.employee.birth_date = DateTime.fromJSDate(finalDate).toFormat(this.format);
                this.errors[target.name] = false;
                this.changed[target.name] = true;
                return true;

            } else if (type === 'expiration' && (new Date() <= finalDate)) {
                // console.log ('Good ' + finalDate);
                this.errors[target.name] = false;
                this.changed[target.name] = true;

                return true;

            } else if (type === 'expiration' && new Date() > finalDate) {
                // Expired
                // console.log ('Expired');
                this.changed[target.name] = false;
                this.errors[target.name] = true;
                return false;
            } else if (type === 'certification' && finalDate > new Date()) {
                // Can't be future certified
                // console.log ('Cannot be future certified');
                this.errors[target.name] = true;
                return false;
            } else if (type === 'certification' && finalDate > oneYearAgo) {
                // console.log ('Good ' + finalDate);
                this.errors[target.name] = false;

                let fixedDate = DateTime.fromJSDate(finalDate).toFormat(this.format);
                this.localFormatCertificationDate = fixedDate;

                return true;
            } else {
                // console.log ('Not sure ' + finalDate);
                this.errors[target.name] = true;
                return false;
            } 
        },

        // Broken.  simplify to only limit dashes and numerals
        cleaveSSNBroken(newValue, oldValue) {
            let lastChar = newValue.slice(-1);
            let result = undefined;

            switch (newValue.length) {
                case 0:
                    break;;
                case 1:
                case 2:
                case 3:
                case 5:
                case 6:
                case 8:
                case 9:
                case 10:
                case 11:
                    // Don't allow anything but numbers
                    if (! lastChar.match(/[0-9]/)) result = oldValue; 
                    break;;
                case 4:
                    // Don't allow anything but numbers
                    if (lastChar.match(/[0-9]/)) result = oldValue + '-' + lastChar; 
                    else if (lastChar !== '-') result = oldValue; 
                    break;;
                case 7:
                    // Don't allow anything but numbers
                    if (lastChar.match(/[0-9]/)) result = oldValue + '-' + lastChar; 
                    else if (lastChar !== '-') result = oldValue; 
                    break;;

                default:
                    result = oldValue;
            }
            if (result == oldValue) return false;
            else return result;
        },

        cleaveSSN2(newValue, oldValue, field) {
            let f1 = field[0];
            let f2 = field[1];
            let lastChar = newValue.slice(-1);

            switch (newValue.length) {
                case 0:
                    break;;
                case 1:
                case 2:
                case 3:
                case 5:
                case 6:
                case 8:
                case 9:
                case 10:
                case 11:
                    // Don't allow anything but numbers
                    if (! lastChar.match(/[0-9]/)) this[f1][f2] = oldValue; 
                    break;;
                case 4:
                    // Don't allow anything but numbers
                    if (lastChar.match(/[0-9]/)) this[f1][f2] = oldValue + '-' + lastChar; 
                    else if (lastChar !== '-') this[f1][f2] = oldValue; 
                    break;;
                case 7:
                    // Don't allow anything but numbers
                    if (lastChar.match(/[0-9]/)) this[f1][f2] = oldValue + '-' + lastChar; 
                    else if (lastChar !== '-') this[f1][f2] = oldValue; 
                    break;;

                default:
                    this[f1][f2] = oldValue;
            }
        },

        cleaveFein(newValue, oldValue, field) {
            let f1 = field[0];
            let f2 = field[1];
            let lastChar = newValue.slice(-1);

            switch (newValue.length) {
                case 0:
                    break;;
                case 1:
                case 2:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    // Don't allow anything but numbers
                    if (! lastChar.match(/[0-9]/)) this[f1][f2] = oldValue; 
                    break;;
                case 3:
                    // Don't allow anything but numbers
                    if (lastChar.match(/[0-9]/)) this[f1][f2] = oldValue + '-' + lastChar; 
                    else if (lastChar !== '-') this[f1][f2] = oldValue; 
                    break;;

                default:
                    this[f1][f2] = oldValue;
            }
        },

        cleaveDate(newValue, oldValue, field) {
            let f1 = field[0];
            let f2 = field[1];
            let lastChar = newValue.slice(-1);

            let month, day, year = false;

            switch (newValue.length) {
                case 0:
                    break;;
                case 1:
                    if (lastChar.match(/[2-9]/)) {
                        month = true;
                        this[f1][f2] = '0' + lastChar + '/'; 
                    }
                    else if (lastChar.match(/[01]/)) {}
                    else this[f1][f2] = oldValue;
                    break;;
                case 2:
                    if (month) break;
                    else if (oldValue.match(/^1/) && lastChar.match(/[0-2]/)) { month = true; this[f1][f2] = oldValue + lastChar + '/'; }
                    else if (oldValue.match(/^1/) && ! lastChar.match(/[0-2]/)) { month = false; this[f1][f2] = oldValue; }
                    else if (lastChar.match(/[1-9]/)) {
                        month=true;
                        this[f1][f2] = oldValue + lastChar + '/';
                    } else {
                        month = false;
                        this[f1][f2] = oldValue;
                    }
                    break;
                case 3:
                    if (month) break;
                    else if (lastChar == '/') month = true;
                    else { month = false; this[f1][f2] = oldValue; } 
                    break;
                case 4:
                    if (lastChar.match(/[4-9]/)) {
                        day = true;
                        this[f1][f2] = oldValue + '0' + lastChar + '/'; 
                    }
                    else if (lastChar.match(/[0-3]/)) { day = false;}
                    else {
                        day = false;
                        this[f1][f2] = oldValue;
                    }
                    break;;
                case 5:
                    if (day) break;
                    else if (oldValue.match(/3$/) && lastChar.match(/[0-1]/)) { day=true; this[f1][f2] = oldValue + lastChar + '/'; }
                    else if (oldValue.match(/3$/) && ! lastChar.match(/[0-1]/)) { day=false; this[f1][f2] = oldValue; }
                    else if (lastChar.match(/[1-9]/)) {
                        day=true;
                        this[f1][f2] = oldValue + lastChar + '/';
                    } else {
                        day = false;
                        this[f1][f2] = oldValue;
                    }
                    break;
                case 6:
                    if (day) break;
                    else if (lastChar == '/') day = true;
                    else this[f1][f2] = oldValue; 
                    break;
                case 7:
                    if (! lastChar.match(/[0-9]/)) this[f1][f2] = oldValue; 
                    break;;
                case 8:

                case 9:

                case 10:
                    if (! lastChar.match(/[0-9]/)) this[f1][f2] = oldValue; 
                    else this[f1][f2] = newValue;
                    break;;
                default:
                    this[f1][f2] = oldValue;
            }
        },

        closeWindow() {
            if (window && window.opener) {
                if (this.changes.length > 0) {
                    this.createDialog({ "title": "Are You Sure?", "body": "You may lose your work.  Proceed?",
                        "buttonYesAction": function () { window.close(); },
                    });
                } else {
                    window.close();
                }
            } else {
                this.cancelCurrent();
            }
        },

        validateDdPercentage() {
            // Do basic percentage checking
            let bank1Percent = Math.round(this.assignment.dd_bank_percent_1 ? this.assignment.dd_bank_percent_1.replace(/[^0-9\.]+/, '') : 0);
            let bank2Percent = Math.round(this.assignment.dd_bank_percent_2 ? this.assignment.dd_bank_percent_2.replace(/[^0-9\.]+/, '') : 0);
            if (bank1Percent > 100) bank1Percent = 100;
            if (bank2Percent > 100) bank2Percent = 100;
            const total = bank1Percent + bank2Percent;
            const originalOptinSetting = this.employee.papercheck_optin;
            this.ddMessage2 = false

            // only has bank 1 info or user sets bank 1 to 100%, unset bank 2
            if (this.assignment.dd_status == 1 || bank1Percent >= 100) {
                // Don't use bank 2 
                this.assignment.dd_bank_percent_2 = '0%';
                this.assignment.dd_bank_amount_2 = '';
                if (bank2Percent > 0) {
                    this.ddMessage2 = true;
                }
                bank2Percent = 0;

                // If bank1 is 100%, fix bank2 and fixed amounts. We also need to handle a case where they
                //  selected one account but somehow imported data for 2 banks. Need to set bank 1 to 100%
                if (bank1Percent >= 100 || total >= 100) {
                    this.ddMessage = false;
                    // Set to 100% and don't allow the use of fixed amounts
                    bank1Percent = 100;
                    this.assignment.dd_bank_percent_1 = '100';
                    this.assignment.dd_bank_amount_1 = '';
                    this.employee.papercheck_optin = originalOptinSetting || false; // Go Paperless since they are 100% DD unless they specified paper
                } else if (bank1Percent > 0 && bank1Percent < 100) {
                    this.ddMessage = true;
                    this.assignment.dd_bank_percent_1 = bank1Percent;
                    this.assignment.dd_bank_amount_1 = '';
                    this.employee.papercheck_optin = true; // Send paper since they are not 100% DD
                } else if (this.assignment.dd_bank_amount_1 && this.assignment.dd_bank_amount_1 > 0) {
                    this.ddMessage = true;
                    this.employee.papercheck_optin = true; // Send paper since they are not 100% DD
                }

                // add '%' for users
                if (bank1Percent && bank1Percent > 0) this.assignment.dd_bank_percent_1 = String(bank1Percent) + '%';
                // override bank percent and amount otherwise, will not be updated some values
                this.addDdFormChanged();
                return;

            // has 2 banks
            } else if (this.assignment.dd_status == 2) {
                // Make sure total does not go above 100% for bank 1 and 2
                if (total >= 100) {
                    this.ddMessage = false;
                    if (total > 100) {
                        this.ddMessage2 = true;
                    }
                    // Set to 100% and don't allow the use of fixed amounts
                    bank2Percent = 100 - bank1Percent < 0 ? 0 : 100 - bank1Percent;
                    this.assignment.dd_bank_percent_2 =  bank2Percent;
                    this.assignment.dd_bank_amount_2 = '';
                    this.assignment.dd_bank_percent_1 =  bank1Percent;
                    this.assignment.dd_bank_amount_1 = '';
                    this.employee.papercheck_optin = originalOptinSetting || false; // Go Paperless since they are 100% DD unless they specified paper
                } else if (bank2Percent > 0 && bank2Percent < 100) {
                    this.ddMessage = true;
                    // make sure that we don't allow to input both
                    this.assignment.dd_bank_percent_2 = bank2Percent;
                    this.assignment.dd_bank_amount_2 = '';
                    this.employee.papercheck_optin = true; // Send paper since they are not 100% DD
                } else if (this.assignment.dd_bank_amount_2) {
                    this.ddMessage = true;
                    this.employee.papercheck_optin = true; // Send paper since they are not 100% DD
                }

                // Handle situation where someone added 2 bank accounts but bank 1 is 100%
                if (bank1Percent >= 100) {
                    this.ddMessage = false;
                    if (bank2Percent > 0) {
                        this.ddMessage2 = true;
                    }
                    // Set to 100% and don't allow the use of fixed amounts
                    bank1Percent = 100;
                    this.assignment.dd_bank_percent_1 = '100%';
                    this.assignment.dd_bank_amount_1 = '';
                    this.employee.papercheck_optin = originalOptinSetting || false; // Go Paperless since they are 100% DD unless they specified paper

                    // Disable bank2
                    bank2Percent = 0;
                    this.assignment.dd_bank_percent_2 = '';
                    this.assignment.dd_bank_amount_2 = '';

                // Check for bank1. If no values, move bank 2 to bank 1
                } else if (bank1Percent === 0 && parseFloat(this.assignment.dd_bank_amount_1) === 0) {
                    this.assignment.dd_bank_percent_1 = bank2Percent
                    this.assignment.dd_bank_amount_1 = this.assignment.dd_bank_amount_2;
                    this.assignment.dd_bank_percent_2 = ''
                    this.assignment.dd_bank_amount_2 = ''
                    bank2Percent = 0;
                    this.assignment.dd_status = 1;
                }
                if (bank1Percent && bank1Percent > 0) this.assignment.dd_bank_percent_1 = String(bank1Percent) + '%';
                if (bank2Percent && bank2Percent > 0) this.assignment.dd_bank_percent_2 = String(bank2Percent) + '%';

                this.addDdFormChanged();
                return;
            }

            // If here, no dd
            this.employee.papercheck_optin = true; // Send paper since they are not 100% DD
            this.addDdFormChanged();
        },

        autoSetDd2Percentage() {
            if (this.assignment.dd_status == 1) {
                // only bank 1, run validate function
                this.validateDdPercentage();
            } else if (this.assignment.dd_status == 2) {
                // has bank 2, autoset
                let bank1Percent = Math.round(this.assignment.dd_bank_percent_1 ? this.assignment.dd_bank_percent_1.replace(/[^0-9\.]+/, '') : 0);

                if (bank1Percent >= 100) {
                    // over 100% -> can't allow, set bank 1 percentage 100% and remove amount
                    this.assignment.dd_bank_amount_1 = '';
                    this.assignment.dd_bank_percent_1 = '100%';
                    this.assignment.dd_bank_percent_2 = '0%';
                    this.ddMessage2 = true
                } else {
                    // If user set bank 1 to 0%, remain bank 1 amount If there is.
                    if (bank1Percent > 0) this.assignment.dd_bank_amount_1 = '';
                    this.assignment.dd_bank_percent_1 = bank1Percent + '%';
                    this.assignment.dd_bank_percent_2 = (100 - bank1Percent) + '%';
                }
                // when user change bank 1 percentage, will set bank 2 percentage. It will be matched 100%
                this.assignment.dd_bank_amount_2 = '';
                this.ddMessage = false;
                // override bank percent and amount otherwise, will not be updated some values
                this.addDdFormChanged();
            }
        },

        resetDd() {
            // reset at least percent and amount. if not, user change bank 2 to bank 1, It may be calculated wrong
            if (this.assignment.dd_status >= 1) {
                this.assignment.dd_bank_percent_1 = '100%'
                this.assignment.dd_bank_percent_2 = '0%'
                this.assignment.dd_bank_amount_1 = '';
                this.assignment.dd_bank_amount_2 = '';
                // override bank percent and amount otherwise, will not be updated some values
                this.addDdFormChanged();
            } else {
                this.employee.papercheck_optin = true;
                $("input[name='employee.papercheck_optin']").addClass('form-change');
            }
        },

        removeBankPercent(bankNumber) {
            // remove percentage
            if (bankNumber == 1) {
                this.assignment.dd_bank_percent_1 = ''
            } else if (bankNumber == 2) {
                this.assignment.dd_bank_percent_2 = ''
            }
            // running this function mean It is set combined (flat + percentage or percentage + flat)
            this.ddMessage = false;
            // override bank percent and amount otherwise, will not be updated some values
            this.addDdFormChanged();
        },

        addDdFormChanged() {
            $("input[name='dd_bank_percent_1']").addClass('form-change');
            $("input[name='dd_bank_percent_2']").addClass('form-change');
            $("input[name='dd_bank_amount_1']").addClass('form-change');
            $("input[name='dd_bank_amount_2']").addClass('form-change');
            $("input[name='employee.papercheck_optin']").addClass('form-change');
        },

        // Add more complex logic for custom forms
        requireCustomFormField(fieldObject = null) {
            if (!fieldObject || typeof fieldObject !== 'object') {
                return false;
            } else if (fieldObject.validation && fieldObject.validation.required) {
                let fieldToCheck, fieldValueToCheck, currentFieldValue;
                if (fieldObject.validation.required.state_form_field) {
                    fieldToCheck = (this.employee.state_form_fields || {})[fieldObject.validation.required.state_form_field];
                    fieldValueToCheck = fieldObject.validation.required.value;
                    currentFieldValue = fieldToCheck.value;
                    return (currentFieldValue === fieldValueToCheck) ? true : false;
                } else if (fieldObject.validation.required.custom_document_field) {
                    fieldToCheck, currentFieldValue = fieldObject.validation.required.custom_document_field;
                } else if (fieldObject.validation.required.employeeField) {
                    fieldToCheck, currentFieldValue = fieldObject.validation.required.employeeField;
                } else if (fieldObject.validation.required.assignmentField) {
                    fieldToCheck, currentFieldValue = fieldObject.validation.required.assignmentField;
                }

                return true;
            } else if (parseInt(fieldObject.required) === 1) {
                return true;
            }
        },

        validateCustomFormField(fieldObject) {
            console.log(fieldObject.name, fieldObject.value);
            return true
        },

        changedValue(field) {
            // to remove highlighted fields after change
            if (this.errors[field]) this.errors[field] = false;
            if (!this.changed[field]) this.changed[field] = true;

            // IF user click default value ('choose one') after user got error for empty value, user might be stuck. so If that case, we should remove highlighted empty fields (Doc number, exp)
            if (field == 'ee_list_a_type_id' && !this.assignment.ee_list_a_type_id) {
                this.removeError('ee_list_a_');
            } else if (field == 'ee_list_b_type_id' && !this.assignment.ee_list_b_type_id && !this.assignment.ee_list_c_type_id) {
                this.removeError('ee_list_b_');
                this.removeError('ee_list_c_');
                this.errors.ee_list_c_type_id = false;
            } else if (field == 'ee_list_c_type_id' && !this.assignment.ee_list_c_type_id && !this.assignment.ee_list_b_type_id) {
                this.removeError('ee_list_c_');
                this.removeError('ee_list_b_');
                this.errors.ee_list_b_type_id = false;
            } else if (field == 'list_a_type_id' && !this.assignment.list_a_type_id) {
                this.removeError('list_a_');
            } else if (field == 'list_b_type_id' && !this.assignment.list_b_type_id && !this.assignment.list_c_type_id) {
                this.removeError('list_b_');
                this.removeError('list_c_');
                this.errors.list_c_type_id = false;
            } else if (field == 'list_c_type_id' && !this.assignment.list_c_type_id && !this.assignment.list_b_type_id) {
                this.removeError('list_c_');
                this.removeError('list_b_');
                this.errors.list_b_type_id = false;
            }
        },

        removeError(name) {
            // reset doc number, expire date in I9
            if (!this.assignment[name + 'number'] && this.errors[name + 'number']) this.errors[name + 'number'] = false;
            if (!this.assignment[name + 'exp'] && this.errors[name + 'exp']) this.errors[name + 'exp'] = false;
        },

        getHistory() {
            if (! this.assignment || !this.assignment.hash || this.type === 'employee') return false;
            this.oasisApi.get(this.endpoints.assignment + '/history')
                .then(response => {
                    if (response.status == 200 && typeof response.data === 'object') {
                        this.history = response.data;
                    }
                })
                .catch(error => { console.log(error); }
            );
        },

        copyAssignment() {
            if (this.assignment && this.assignment.hash && this.type === 'employer') {
                window.location.href = '/oasis/starts/createNew/' + this.assignment.hash;
            } else {
                return false;
            }
        },
    },

    async created() {
        this.format = this.getDateFormat();
        this.oasisApi = new Axios('/restv2');
        this.projectLocations = (await this.oasisApi.get('/projectlocations')).data;
        const response = await this.oasisApi.get('/entities')
        this.entity = response.data;
        if ( (this.entity.post_start_date && this.entity.post_end_date ) || (this.entity.prep_start_date && this.entity.prep_end_date) ) this.hasPrepWrap = true;
        this.harassmentCertification = parseInt((this.entity || {}).certification_enabled || 0) > 0 ? true : false; // false = do not require
        if (response.data.hasOwnProperty('other_properties') && response.data.other_properties) {
            const data = typeof response.data.other_properties === 'string' && this.isJson(response.data.other_properties) ? JSON.parse(response.data.other_properties) : response.data.other_properties;
            this.disableLoanouts = data.disableLoanouts || false; 
            this.enableLoanoutsEmployee = data.enableLoanoutsEmployee || false;
            this.enforceLoanoutI9 = data.enforceLoanoutI9 || false; 
            this.requireI9Information = data.requireI9Information || false; 
            this.encourageLicenseUpload = data.encourageLicenseUpload || false;
            this.stateFormsNotRequired = data.stateFormsNotRequired || false; // False = do not require
            this.companyHarassmentSupCertificateId = data.companyHarassmentSupCertificateId || null; // null = do not require
            this.companyHarassmentCertificateId = data.companyHarassmentCertificateId || null; // null = do not require
        }

        this.oasisApi.get('/states')
            .then(response => { this.states = response.data.map(({id, name, code, country_id}) => ({ id: id, name: name, code: code, country_id: country_id}))})
            .catch(error => { console.log(error); });

        this.addStateForms();

        if (typeof jwtToken !== 'undefined' && jwtToken) {
            this.oasisV3Api = new Axios('/restv3');
            const certificationTypes = await this.oasisV3Api.get('/certifications');
            if (certificationTypes && certificationTypes.data && certificationTypes.data.results) {
                this.certificationTypes = certificationTypes.data.results;
            }
        }
    },

    mounted() {
        // vue-multiselect has a bug for tab key event. so we implement event via JQuery
        $('.multiselect__input').keydown(function (event) { // watch for keydown events on elements with class multiselect
            if (event.which === 9) { // if event is tab
               var e = $.Event('click'); // create click event
               $(event.target).parent().siblings().find('.multiselect__option--highlight').trigger(e); // triggered
            }
         });
        if (typeof hash !== 'undefined' && hash) {
            this.waiting = true;
            this.type = type;

            this.endpoints.certifications = '/employee/certifications/';

            if (type === 'employer') {
                this.endpoints.assignment = '/assignments/' + hash;
                // TODO  should be employee_id
                this.endpoints.employee = '/employees/';
                this.endpoints.save = '/assignments/' + hash;
                this.endpoints.printStart = '/printStart/' + hash;
                this.endpoints.customDocuments = '/customDocuments/';

                let employer
                if (typeof user !== 'undefined' && typeof user === 'object') {
                    employer = user;
                } else if (typeof user !== 'undefined') {
                    employer = JSON.parse(user);
                } else {
                    employer = {}
                }
                this.employer.id = employer.id;
                this.employer.signature = employer.signature;
                this.employer.first_name = employer.first_name;
                this.employer.last_name = employer.last_name;
            } else if (type === 'employee') {
                this.endpoints.assignment = '/employee/start/' + hash;
                // TODO  should be employee_id
                this.endpoints.employee = '/employee/lookup/';
                this.endpoints.save = '/employee/start/' + hash;
                this.endpoints.printStart = '/employee/printStartUrl/' + hash;
                this.endpoints.customDocuments = '/customDocuments/';
            } else {
                return undefined;
            }
            this.oasisApi.get(this.endpoints.assignment)
                .then(response => {
                    if (response.status == 200) {
                        let assignmentData = response.data
                        this.updateAssignment(assignmentData);
                        this.loadStartList();
                        // TODO  should be employee hash?
                        return assignmentData;
                    } else if (response.status == 400 || response.status == 403) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                        return false;
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        return false;
                    } 
                })
                .then(assignmentData => {
                    this.waiting = false;
                    if (assignmentData) {
                        this.oasisApi.get(this.endpoints.employee + assignmentData.employee_id)
                            .then(response => {
                                this.updateEmployee(response.data);
                                this.getCertifications();
                            })
                            .catch(error => {
                                console.log(error);
                                this.waiting = false;
                            })
                        ;
                    }
                    // this.employee = { "name": response.data.employee, "id": response.data.employee_id };
                })
                .catch(error => {
                    console.log(error);
                    this.waiting = false;
                }
            );
        } else if (type === 'certification') {
            // to get asset on employee certification page.
            let assignment = {
                hash: employeeHash,
                id: certificationAssignmentId,
                employee_id: certificationEmployeeId
            };
            this.getAssets(assignment);
            this.endpoints.certifications = '/employee/certifications/';
            this.assignment.id = certificationAssignmentId || undefined;
            this.assignment.employee_id = certificationEmployeeId || undefined;
            this.employee.id = this.certificationStatus.employee_id = certificationEmployeeId || undefined;
            this.employee.hash = employeeHash || undefined;
            this.assignment.certification_type_id = this.certificationStatus.certification_type_id = certificationTypeId || undefined;
            return true;
        }
        if (typeof directDeposit !== 'undefined' && directDeposit) this.directDeposit = true;

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        }
        if (loanoutEntityTypes) this.entityType = JSON.parse(loanoutEntityTypes);
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
    }
}).mount("#start-app");

